import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../StateContext/Application";
import { apiurl } from "../../../../path";
import { useLanguage } from "../../../../lang/langcontext/LanguageContext";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import GooglePagination from "../../styles/GooglePagination";
import CommonFilters from '../../../../utils/CommonFilters';

const GrOutwards = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const context = useContext(AdminContext);
  const { GetAllProjectList, GetBudgetHeadInfo, Usermenu, GetWorksByGR, GetMyDepartmentAccess } =
    context;

    //   const parseIds = (v) => {
    //   try {
    //     const p = typeof v === "string" ? JSON.parse(v) : v;
    //     return (Array.isArray(p) ? p : [p]).map(Number).filter(Boolean);
    //   } catch {
    //     return [];
    //   }
    // };

    const parseIds = (value) => {
  if (value === null || value === undefined || value === "") {
    return [];
  }

  if (Array.isArray(value)) {
    return value.map(Number).filter((id) => Number.isInteger(id) && id > 0);
  }

  const normalized = String(value)
    .replace(/[\[\]"]/g, "")
    .split(",")
    .map((id) => Number(id.trim()))
    .filter((id) => Number.isInteger(id) && id > 0);

  return normalized;
};


      const [worksData, setWorksData] = useState([]);
      const [myDepartments, setMyDepartments] = useState([]);
      const [selectedDepartment, setSelectedDepartment] = useState("");
      useEffect(() => {
        (async () => {
          try {
            const r = await GetMyDepartmentAccess();
            setMyDepartments(r?.data?.departments || []);
          } catch (e) {
            console.error("GetMyDepartmentAccess failed", e);
          }
        })();
      }, []);




  // const fetchWorksByGR = async (grid) => {
  //   setloading(true);
  //   try {
  //     let data = await GetWorksByGR(grid);
  //     if (data.status) {
  //       setWorksData(data.message);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching works:", error);
  //   } finally {
  //     setloading(false);
  //   }
  // };

  const fetchWorksByGR = async (grid) => {
    setloading(true);
    try {
      let data = await GetWorksByGR(grid);
      if (data.status) {
        setWorksData(data.message);
      }
    } catch (error) {
      console.error("Error fetching works:", error);
    } finally {
      setloading(false);
    }
  };
  console.log("worksData: ", worksData);

  const [project, setProjectList] = useState([]);
  const [proposallist, setProposalList] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [technicalInwards, setTechnicalInwards] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const budgetEstimation = proposallist;
  const billsPerPage = 10;
  const [selectedProposal, setSelectedProposal] = useState(null);
  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const sortedBills = Array.isArray(filteredBills)
    ? filteredBills
        .slice() // ✅ prevent state mutation
        .sort((a, b) => new Date(b.Date) - new Date(a.Date))
    : [];
  const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);
  // const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

  const [exportingPDF, setExportingPDF] = useState(false);

  const displayedGRS = exportingPDF ? filteredBills : currentBills;
  const [searchTerm, setSearchTerm] = useState("");
  const [statusofData, setstatusofData] = useState("");
  const [SelectedHeadCode, setSelectedHeadCode] = useState("");

  const [showmenu, setShowmenu] = useState(1);
  const [grId, setgrID] = useState("");
  const [grNumber, setgrNumber] = useState("");
  const [grlogData, setgrlogData] = useState([]);
  const [filteredlogBills, setFilteredlogBills] = useState([]);
  const [currentlogPage, setcurrentlogpage] = useState(1);
  const totallogPages = Math.ceil(filteredlogBills?.length / billsPerPage);
  const indexOfLastlogBill = currentlogPage * billsPerPage;
  const indexOfFirstlogBill = indexOfLastlogBill - billsPerPage;
  const currentlogBills = filteredlogBills?.slice(
    indexOfFirstlogBill,
    indexOfLastlogBill,
  );
  const [UserRole, setUserRole] = useState("");
  const [AllDistrict, setAllDistrict] = useState([]);
  const [TalukasofDistrict, setTalukasofDistrict] = useState([]);
  const [SelectedDistrict, setSelectedDistrict] = useState([]);
  const [LoggedInDistrict, setLoggedInDistrict] = useState("");
  const [SelectedTalukasofDistrict, setSelectedTalukasofDistrict] =
    useState("");
  const [openDistrict, setOpenDistrict] = useState(false);
  const [RoleID, setroleID] = useState(null);
  const [typeofData, settypeofData] = useState("District");
  const [loading, setloading] = useState(false);
    const [selectedHeadCodeFilter, setSelectedHeadCodeFilter] = useState("");
  const headerStyle = {
    padding: "12px 16px",
    whiteSpace: "nowrap",
    borderRight: "1px solid #e0e0e0",
    textTransform: "capitalize",
  };

  const getProjectList = async () => {
    let data = await GetAllProjectList();
    const { status, message, Tabletype, District } = data;
    if (status) {
      let resultData = message;
      if (Tabletype != "State") {
        resultData = message.filter((item) => item.ZillaParishad == District);
        setLoggedInDistrict(District); 
      }
      setProjectList(resultData);
      setTechnicalInwards(resultData);
      setProposalList(resultData);
      setUserRole(Tabletype);
    } else {
      alert(message);
    }
  };

  const getmenu = async () => {
    try {
      const data = await Usermenu();
      if (!data || typeof data !== "object") {
        console.error("Invalid data:", data);
        return;
      }
      const roleID = data?.Data?.RoleID;
      setroleID(roleID);
      console.log("sffdsf", data?.Data);
    } catch (error) {
      console.error("Error in AdminNavbar getmenu:", error);
    }
  };
  useEffect(() => {
    getProjectList();
    getmenu();
  }, []);

  useEffect(() => {
    setSelectedTalukasofDistrict("");
    setSelectedHeadCode("");
  }, [SelectedDistrict]);

  //     useEffect(() => {
  //     let filtered = [...technicalInwards];

  //     // 🔹 Filter by District
  //     if (SelectedDistrict) {
  //         filtered = filtered.filter(
  //             item => item.ZillaParishad === SelectedDistrict
  //         );
  //     }

  //     // 🔹 Filter by Taluka
  //     if (SelectedTalukasofDistrict) {
  //         filtered = filtered.filter(
  //             item => item.Taluka === SelectedTalukasofDistrict
  //         );
  //     }

  //     // 🔹 Filter by Status
  //     if (statusofData !== "") {

  //         if (statusofData === "false") {
  //             // Pending / Not approved
  //             filtered = filtered.filter(
  //                 item =>
  //                     item.GRStatus !== "Rejected" &&
  //                     (
  //                         item.Approve1 === "false" ||
  //                         item.Approve2 === "false" ||
  //                         item.Approve3 === "false"
  //                     )
  //             );
  //         }
  //         else if (statusofData === "Rejected") {
  //             filtered = filtered.filter(
  //                 item => item.GRStatus === "Rejected"
  //             );
  //         }
  //         else {
  //             filtered = filtered.filter(
  //                 item => item.GRStatus === statusofData
  //             );
  //         }
  //     }

  //     // 🔹 Search filter
  //     if (searchTerm.trim() !== "") {
  //         const lower = searchTerm.toLowerCase();
  //         filtered = filtered.filter(item =>
  //             Object.values(item).some(val =>
  //                 (val ?? "")
  //                     .toString()
  //                     .toLowerCase()
  //                     .includes(lower)
  //             )
  //         );
  //     }

  //     setFilteredBills(filtered);
  //     setCurrentPage(1);

  // }, [
  //     technicalInwards,
  //     SelectedDistrict,
  //     SelectedTalukasofDistrict,
  //     statusofData,
  //     searchTerm
  // ]);
  useEffect(() => {
    let filtered = [...technicalInwards];
    if (typeofData === "District" && RoleID === 29) {
      filtered = filtered.filter(
        (item) =>
          item.HeadCode === "3054-2419(Roads and bridge repair maintenance program)",
      );
      console.log("filtered Date 3054", filtered);
    } else if (typeofData === "State" && RoleID === 29) {
      filtered = filtered.filter(
        (item) => item.HeadCode === "2515-1238(MLA Representative)",
      );
    }

    // 🔹 New: head code filter for District-role users
    if (UserRole === "District" && selectedHeadCodeFilter && selectedHeadCodeFilter !== "All") {
      if (selectedHeadCodeFilter === "District") {
        filtered = filtered.filter(
          (item) =>
            item.HeadCode ===
            "3054-2419(Roads and bridge repair maintenance program)",
        );
      } else if (selectedHeadCodeFilter === "State") {
        filtered = filtered.filter(
          (item) => item.HeadCode === "2515-1238(MLA Representative)",
        );
      }
    }

    // if (SelectedDistrict && SelectedDistrict.length > 0) {
    //   filtered = filtered.filter(
    //     item => SelectedDistrict.includes(item.ZillaParishad)
    //   );
    // }

    // if (SelectedTalukasofDistrict) {
    //   filtered = filtered.filter(
    //     item => item.Taluka === SelectedTalukasofDistrict
    //   );
    // }
    /////////
    // 🔹 Filter by District (MULTI)
    if (SelectedDistrict && SelectedDistrict.length > 0) {
      filtered = filtered.filter((item) => {
        const itemDistrict = item?.ZillaParishad || "";

        return SelectedDistrict.some(
          (district) =>
            itemDistrict === district ||
            itemDistrict.startsWith(`${district}-`)
        );
      });
    }
    // 🔹 Filter by Taluka (single select – unchanged)
    if (SelectedTalukasofDistrict) {
      filtered = filtered.filter(
        (item) => item.Taluka === SelectedTalukasofDistrict,
      );
    }

    // 🔹 Filter by Head Code
    if (SelectedHeadCode) {
      filtered = filtered.filter(
        item => item.HeadCode === SelectedHeadCode
      );
    }

            // 🔹 Filter by Department
    // if (selectedDepartment) {
    //   filtered = filtered.filter((item) =>
    //     parseIds(item.DepartmentAccessID).includes(Number(selectedDepartment)),
    //   );
    // }
    // Department Filter
if (selectedDepartment !== "") {
  const departmentId = Number(selectedDepartment);

  filtered = filtered.filter((item) => {
    const departmentIds = parseIds(item.DepartmentAccessID);

    return departmentIds.includes(departmentId);
  });
}



    // 🔹 Filter by Status
    if (statusofData !== "") {
      if (statusofData === "Pending") {
        // Pending / Not approved
        filtered = filtered.filter(
          (item) =>
            item.GRStatus !== "Rejected" &&
            (item.Approve1 === "false" ||
              item.Approve2 === "false" ),
        );
      } else if (statusofData === "Rejected") {
        filtered = filtered.filter((item) => item.GRStatus === "Rejected");
      } else if (statusofData === "Approved") {
        // ✅ Added block
        filtered = filtered.filter(
          (item) =>
            item.Approve1 === "true" &&
            item.Approve2 === "true" ,
        );
      } else {
        filtered = filtered.filter((item) => item.GRStatus === statusofData);
      }
    }

    // 🔹 Search filter
    if (searchTerm.trim() !== "") {
      const lower = searchTerm.toLowerCase();
      filtered = filtered.filter((item) =>
        Object.values(item).some((val) =>
          (val ?? "").toString().toLowerCase().includes(lower),
        ),
      );
    }

    setFilteredBills(filtered);
    setCurrentPage(1);
  }, [
    technicalInwards,
    SelectedDistrict, // array
    SelectedTalukasofDistrict,
     SelectedHeadCode,
    statusofData,
    searchTerm,
    typeofData,
    selectedHeadCodeFilter,  //Addeddddd New
    selectedDepartment,      // नवीन
  ]);
  const selectedBillDetails = (BillID) => {
    const result = budgetEstimation
      .filter((item) => item.GRID == BillID)
      .map((item) => ({
        "GR UID": item.GRID,
        "GR Number": item.GRNumber,
        "Head Code": item.HeadCode,
        "Proposal Year": item.ProposalYear,
        District: item.ZillaParishad,
        Taluka: item.Taluka,
        "Work Amount": item.GRAmount,
        "GR Copy": item.GRCopy,
        "GR Approval Copy": item.GRDraftCopy,
        "Creation Date": new Date(item.Date).toLocaleString(),
      }));

    console.log("------------------", result);
    setSelectedProposal(result[0]);
  };

  const logofgridfetchfunction = async (id, idNumber) => {
  setgrID(id);
  try {
    let obj = {
      GRID: id,
      GRnumber: idNumber,
    };

    let res = await GetBudgetHeadInfo(obj, "GetAlllogofparticulardatafromGrID");
    console.log(res);

    const logs = Array.isArray(res) ? res : [];
    setgrlogData(logs);
    setFilteredlogBills(logs);

    if (!Array.isArray(res)) {
      // backend returned an error string/object instead of data
      console.warn("Unexpected logs response:", res);
    }
  } catch (err) {
    alert("Internal Server Error");
    setgrlogData([]);
    setFilteredlogBills([]);
  }
};

//--> old code
  // const logofgridfetchfunction = async (id, idNumber) => {
  //   setgrID(id);
  //   try {
  //     let obj = {
  //       GRID: id,
  //       GRnumber: idNumber,
  //     };

  //     let res = await GetBudgetHeadInfo(
  //       obj,
  //       "GetAlllogofparticulardatafromGrID",
  //     );
  //     console.log(res);
  //     setgrlogData(res);
  //     setFilteredlogBills(res);
  //   } catch (err) {
  //     alert("Internal Server Error");
  //   }
  // };

  const FetchGramPanachayatInfo = async () => {
    try {
      let res = await GetBudgetHeadInfo("null", "AllDistrict");
      // console.log("Data i get:: ", res);
      setAllDistrict(res);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    FetchGramPanachayatInfo();
  }, []);
useEffect(() => {
  if (UserRole === "State") {
    if (SelectedDistrict?.length > 0) {
      const res = AllDistrict.filter((item) => {
        const itemDistrict = item?.District_Marathi || "";
        return SelectedDistrict.some(
          (district) =>
            itemDistrict === district ||
            itemDistrict.startsWith(`${district}-`)
        );
      });
      setTalukasofDistrict(res);
    } else {
      setTalukasofDistrict([]);
    }
  } else if (LoggedInDistrict) {
    // District-login user: taluka list is always their own district's talukas
    const res = AllDistrict.filter((item) => {
      const itemDistrict = item?.District_Marathi || "";
      return itemDistrict === LoggedInDistrict || itemDistrict.startsWith(`${LoggedInDistrict}-`);
    });
    setTalukasofDistrict(res);
  }
}, [SelectedDistrict, AllDistrict, UserRole, LoggedInDistrict]);

  const totalProposalAmount = filteredBills?.reduce((sum, item) => {
    const amount = Number(item?.GRAmount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);

  const pagetotalProposalAmount = currentBills?.reduce((sum, item) => {
    const amount = Number(item?.GRAmount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);
  const exportTableByClassToExcel = async (
    filteredBills,
    UserRole,
    filename = "GR_Report.xlsx",
  ) => {
    if (!Array.isArray(filteredBills) || filteredBills.length === 0) {
      alert("No data available");
      return;
    }
    setloading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    try {
      let totalGRAmount = 0;

      const excelData = filteredBills.map((proposal, index) => {
        const grAmount = Number(proposal.GRAmount || 0);
        totalGRAmount += isNaN(grAmount) ? 0 : grAmount;

        return {
          "Sr.No": index + 1,
          "GR UID": proposal.GRID || "-",
          "GR Number": proposal.GRNumber || "-",
          // "Head Code": proposal.HeadCode || "-",
          // "Work Name": proposal.Work_name || "-",
          "Approved Year": proposal.ProposalYear || "-",
          "District": proposal.ZillaParishad || "-",
          "Taluka": proposal.Taluka || "-",
          "Work Amount": grAmount,

          // "GR Copy": proposal.GRCopy || "No File",
          // "GR Approval Copy": proposal.GRDraftCopy || "No File",

          "Creation Date": proposal.Date ? new Date(proposal.Date).toLocaleString() : "-",

          "Uploaded By": proposal.Uploadedby || "--",
          "Edited By": proposal.EditedBy || "No One",

          "Rejected / Send Back":
            proposal.GRStatus === "Pending" ? "No" : proposal.GRStatus || "-",

          Remark: proposal.Remark || "--",

          "RDD Section Officer":
            proposal.Approve2 === "true"
              ? "✓"
              : proposal.Approve2 === "false"
                ? "✕"
                : "-",

          
        };
      });

      /* ---- TOTAL ROW ---- */
      excelData.push({
        "Sr.No": "",
        "GR UID": "",
        "GR Number": "",
        // "Head Code": "",
        // "Work Name": "",
        "Approved Year": "",
        District: "",
        Taluka: "TOTAL AMOUNT",
        "Work Amount": totalGRAmount,

        // "GR Copy": "",
        // "GR Approval Copy": "",
        "Creation Date": "",
        "Uploaded By": "",
        "Edited By": "",
        "Rejected / Send Back": "",
        Remark: "",
        "RDD Section Officer": "",
        "Deputy / Joint Secretary": "",
      });

      const worksheet = XLSX.utils.json_to_sheet(excelData);

      worksheet["!cols"] = Object.keys(excelData[0]).map(() => ({ wch: 24 }));
      worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };

      // Autofilter only on data rows (exclude TOTAL)
      worksheet["!autofilter"] = {
        ref: XLSX.utils.encode_range({
          s: { r: 0, c: 0 },
          e: {
            r: excelData.length - 2,
            c: Object.keys(excelData[0]).length - 1,
          },
        }),
      };

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "GR Report");
      XLSX.writeFile(workbook, filename);
    } catch (error) {
      console.error("Excel Export Error:", error);
    } finally {
      setloading(false); // ✅ ALWAYS stop loader
    }
  };


  const allDistricts = [
    ...new Set(
      AllDistrict?.map((d) =>
        d?.District_Marathi?.split("-")[0]?.trim()
      ).filter(Boolean)
    ),
  ].sort();

  const isAllSelected = SelectedDistrict.length === allDistricts.length;

  const toggleDistrict = (district) => {
    setSelectedDistrict((prev) =>
      prev.includes(district)
        ? prev.filter((d) => d !== district)
        : [...prev, district],
    );
  };

  const toggleAllDistricts = () => {
    setSelectedDistrict(isAllSelected ? [] : allDistricts);
  };
    // Added New: For download pdf starts from 1 to End...
  const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
    const CHUNK_SIZE = 500;

    setExportingPDF(true);
    setloading(true);

    // Wait for React to render ALL filtered records
    await new Promise((resolve) => setTimeout(resolve, 600));

    const originalTable = document.querySelector(`.${tableClass}`);

    if (!originalTable) {
      setExportingPDF(false);
      setloading(false);
      return;
    }

    try {
      const headerCellsRef = Array.from(
        originalTable.querySelectorAll("thead tr th")
      );
      const headerColCount = headerCellsRef.length;

      let amountColIndex = headerCellsRef.findIndex((th) =>
        th.textContent.trim().toLowerCase().includes("amount")
      );
      if (amountColIndex === -1) {
        amountColIndex = headerColCount - 2; // fallback guess
      }
      const allOriginalRows = Array.from(
        originalTable.querySelectorAll("tbody tr")
      );

      const originalRows = allOriginalRows.filter((row) => {
        const cells = row.querySelectorAll("td");

        if (cells.length === 0) return false;
        if (!row.textContent.trim()) return false;

        // Reject rows that use colSpan anywhere (summary/total rows)
        const hasColSpan = Array.from(cells).some(
          (cell) => cell.colSpan && cell.colSpan > 1
        );
        if (hasColSpan) return false;

        // Reject rows with far fewer cells than a real data row
        if (cells.length < headerColCount - 2) return false;

        // Extra safety: skip anything literally containing "Total"
        if (row.textContent.trim().toLowerCase() === "total") return false;

        return true;
      });

      const totalRows = originalRows.length;
      console.log("PDF Total Rows:", totalRows);

      for (let start = 0; start < totalRows; start += CHUNK_SIZE) {
        const end = Math.min(start + CHUNK_SIZE, totalRows);

        let clonedTable;

        try {
          // Clone table
          clonedTable = originalTable.cloneNode(true);

          const clonedTbody = clonedTable.querySelector("tbody");
          if (clonedTbody) {
            clonedTbody.innerHTML = "";
          }

          // Add only the filtered data rows for this chunk
          for (let i = start; i < end; i++) {
            const clonedRow = originalRows[i].cloneNode(true);
            clonedTbody.appendChild(clonedRow);
          }

          const pdfRows = clonedTable.querySelectorAll("tbody tr");

          // Reset Sr. No.
          pdfRows.forEach((row, index) => {
            const firstCell = row.querySelector("td");
            if (firstCell) {
              firstCell.textContent = start + index + 1;
            }
          });
          let totalAmount = 0;

          pdfRows.forEach((row) => {
            const cells = row.querySelectorAll("td");
            const amountCell = cells[amountColIndex];

            if (amountCell) {
              const amountText = amountCell.textContent
                .replace(/,/g, "")
                .replace(/[₹$]/g, "")
                .replace(/\s+/g, "")
                .trim();

              const amount = parseFloat(amountText);

              if (!isNaN(amount)) {
                totalAmount += amount;
              }
            }
          });

          console.log(`PDF Chunk ${start + 1}-${end} Total:`, totalAmount);

          if (clonedTbody) {
            const totalRow = document.createElement("tr");

            // Label cell spans everything BEFORE the Amount column
            const totalLabelCell = document.createElement("td");
            totalLabelCell.textContent = "Total";
            totalLabelCell.style.fontWeight = "bold";
            totalLabelCell.style.textAlign = "right";
            totalLabelCell.colSpan = Math.max(amountColIndex, 1);
            totalRow.appendChild(totalLabelCell);

            // Amount cell sits directly under the Amount column (no spanning)
            const totalAmountCell = document.createElement("td");
            totalAmountCell.textContent = totalAmount.toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
            totalAmountCell.style.fontWeight = "bold";
            totalAmountCell.style.textAlign = "right";
            totalRow.appendChild(totalAmountCell);

            const remainingCols = headerColCount - amountColIndex - 1;
            if (remainingCols > 0) {
              const emptyCell = document.createElement("td");
              emptyCell.colSpan = remainingCols;
              totalRow.appendChild(emptyCell);
            }

            clonedTbody.appendChild(totalRow);
          }

          // Hide cloned table
          clonedTable.style.position = "absolute";
          clonedTable.style.left = "-99999px";
          clonedTable.style.top = "0";

          document.body.appendChild(clonedTable);

          const pdf = new jsPDF("p", "mm", "a4");

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();

          const topMargin = 25;
          const sideMargin = 10;
          const bottomMargin = 15;

          // PDF title
          pdf.setFontSize(16);
          pdf.setFont("helvetica", "bold");

          pdf.text(`${title} (${start + 1} - ${end})`, pageWidth / 2, 15, {
            align: "center",
          });

          // Convert table to canvas
          const canvas = await html2canvas(clonedTable, {
            scale: 1,
            useCORS: true,
            backgroundColor: "#ffffff",
          });

          const imgWidth = pageWidth - sideMargin * 2;
          const pxToMm = imgWidth / canvas.width;
          const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
          const usablePageHeightPx = usablePageHeightMm / pxToMm;

          let renderedHeight = 0;
          let pageNumber = 0;

          while (renderedHeight < canvas.height) {
            const sliceHeight = Math.min(
              usablePageHeightPx,
              canvas.height - renderedHeight
            );

            const pageCanvas = document.createElement("canvas");
            const context = pageCanvas.getContext("2d");

            pageCanvas.width = canvas.width;
            pageCanvas.height = sliceHeight;

            context.drawImage(
              canvas,
              0,
              renderedHeight,
              canvas.width,
              sliceHeight,
              0,
              0,
              canvas.width,
              sliceHeight
            );

            const imgData = pageCanvas.toDataURL("image/jpeg", 0.9);

            if (pageNumber > 0) {
              pdf.addPage();
            }

            pdf.addImage(
              imgData,
              "JPEG",
              sideMargin,
              topMargin,
              imgWidth,
              sliceHeight * pxToMm
            );

            renderedHeight += sliceHeight;
            pageNumber++;
          }

          pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);
        } finally {
          if (clonedTable && clonedTable.parentNode) {
            clonedTable.parentNode.removeChild(clonedTable);
          }
        }

        await new Promise((resolve) => setTimeout(resolve, 300));
      }
    } catch (error) {
      console.error("PDF Export Error:", error);
    } finally {
      setExportingPDF(false);
      setloading(false);
    }
  };
  // const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
  //   const CHUNK_SIZE = 500;
  //   setExportingPDF(true);
  //   setloading(true);
  //   await new Promise((res) => setTimeout(res, 600));
  //   const originalTable = document.querySelector(`.${tableClass}`);
  //   const table = document.querySelector(`.${tableClass}`);
  //   if (!table) {
  //     setExportingPDF(false);
  //     setloading(false);
  //     return;
  //   }
  //   try {
  //     const originalRows = originalTable.querySelectorAll("tbody tr");
  //     const totalRows = originalRows.length;

  //     for (let start = 0; start < totalRows; start += CHUNK_SIZE) {
  //       const end = Math.min(start + CHUNK_SIZE, totalRows);

  //       // 🔥 Clone table
  //       const table = originalTable.cloneNode(true);
  //       const rows = table.querySelectorAll("tbody tr");

  //       // Remove rows outside chunk
  //       rows.forEach((row, index) => {
  //         if (index < start || index >= end) {
  //           row.remove();
  //         }
  //       });

  //       document.body.appendChild(table);
  //       const pdf = new jsPDF("p", "mm", "a4");
  //       const pageWidth = pdf.internal.pageSize.getWidth();
  //       const pageHeight = pdf.internal.pageSize.getHeight();

  //       const topMargin = 25;
  //       const sideMargin = 10;
  //       const bottomMargin = 15;

  //       pdf.setFontSize(16);
  //       pdf.setFont("helvetica", "bold");
  //       pdf.text(`${title} (${start + 1} - ${end})`, pageWidth / 2, 15, {
  //         align: "center",
  //       });

  //       const canvas = await html2canvas(table, {
  //         scale: 1,
  //         useCORS: true,
  //         backgroundColor: "#2C78DB",
  //       });

  //       const imgWidth = pageWidth - sideMargin * 2;

  //       // 🔥 Correct pixel-to-mm ratio
  //       const pxToMm = imgWidth / canvas.width;

  //       const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
  //       const usablePageHeightPx = usablePageHeightMm / pxToMm;

  //       let renderedHeight = 0;
  //       let pageNumber = 0;

  //       while (renderedHeight < canvas.height) {
  //         const sliceHeight = Math.min(
  //           usablePageHeightPx,
  //           canvas.height - renderedHeight,
  //         );

  //         const pageCanvas = document.createElement("canvas");
  //         const context = pageCanvas.getContext("2d");

  //         pageCanvas.width = canvas.width;
  //         pageCanvas.height = sliceHeight;

  //         context.drawImage(
  //           canvas,
  //           0,
  //           renderedHeight,
  //           canvas.width,
  //           sliceHeight,
  //           0,
  //           0,
  //           canvas.width,
  //           sliceHeight,
  //         );

  //         const imgData = pageCanvas.toDataURL("image/jpeg", 0.9);

  //         if (pageNumber > 0) pdf.addPage();

  //         pdf.addImage(
  //           imgData,
  //           "JPEG",
  //           sideMargin,
  //           topMargin,
  //           imgWidth,
  //           sliceHeight * pxToMm,
  //         );

  //         renderedHeight += sliceHeight;
  //         pageNumber++;
  //       }

  //       pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);

  //       document.body.removeChild(table);
  //       await new Promise((resolve) => setTimeout(resolve, 300));
  //     }
  //   } catch (error) {
  //     console.error("PDF Export Error:", error);
  //   } finally {
  //     setExportingPDF(false);
  //     setloading(false);
  //   }
  // };
  // const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
  //   setExportingPDF(true);
  //   await new Promise(res => setTimeout(res, 300));

  //   const table = document.querySelector(`.${tableClass}`);
  //   if (!table) {
  //     setExportingPDF(false);
  //     return;
  //   }

  //   const pdf = new jsPDF("p", "mm", "a4");
  //   const pageWidth = pdf.internal.pageSize.getWidth();
  //   const pageHeight = pdf.internal.pageSize.getHeight();

  //   const topMargin = 25;
  //   const sideMargin = 10;
  //   const bottomMargin = 15;

  //   pdf.setFontSize(16);
  //   pdf.setFont("helvetica", "bold");
  //   pdf.text(title, pageWidth / 2, 15, { align: "center" });

  //   const canvas = await html2canvas(table, {
  //     scale: 1,
  //     useCORS: true,
  //     backgroundColor: "#2C78DB",
  //   });

  //   const imgWidth = pageWidth - sideMargin * 2;

  //   // 🔥 Correct pixel-to-mm ratio
  //   const pxToMm = imgWidth / canvas.width;

  //   const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
  //   const usablePageHeightPx = usablePageHeightMm / pxToMm;

  //   let renderedHeight = 0;
  //   let pageNumber = 0;

  //   while (renderedHeight < canvas.height) {
  //     const sliceHeight = Math.min(
  //       usablePageHeightPx,
  //       canvas.height - renderedHeight
  //     );

  //     const pageCanvas = document.createElement("canvas");
  //     const context = pageCanvas.getContext("2d");

  //     pageCanvas.width = canvas.width;
  //     pageCanvas.height = sliceHeight;

  //     context.drawImage(
  //       canvas,
  //       0,
  //       renderedHeight,
  //       canvas.width,
  //       sliceHeight,
  //       0,
  //       0,
  //       canvas.width,
  //       sliceHeight
  //     );

  //     const imgData = pageCanvas.toDataURL("image/jpeg", 0.9);

  //     if (pageNumber > 0) pdf.addPage();

  //     pdf.addImage(
  //       imgData,
  //       "JPEG",
  //       sideMargin,
  //       topMargin,
  //       imgWidth,
  //       sliceHeight * pxToMm
  //     );

  //     renderedHeight += sliceHeight;
  //     pageNumber++;
  //   }

  //   pdf.save(filename);
  //   setExportingPDF(false);
  // };
  console.log("filteredBills:", filteredBills)
     console.log([...new Set(technicalInwards.map(i => i.HeadCode))], RoleID, UserRole);
     console.log("Selected Department:", selectedDepartment);

console.log("Available Departments:", myDepartments);

console.log(
  "GR Department Data:",
  technicalInwards.slice(0, 10).map((item) => ({
    GRID: item.GRID,
    DepartmentAccessID: item.DepartmentAccessID,
  }))
);

  return (
    <>
      {showmenu == 1 && (
        <div
          className="col-12 pb-5"
          style={{
            backgroundColor: "#EFF3F8",
            height: "90vh",
            overflowX: "hidden",
            overflowY: "scroll",
          }}
        >
          <div
            style={{
              filter: loading ? "blur(4px)" : "none",
              pointerEvents: loading ? "none" : "auto",
              transition: "0.2s ease",
            }}
          >
            <div className="col-11 m-auto">
              <div className="col-12 ">
                {/* <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <h5 className='my-auto fw-bold'>
                                        <img src="/Work-Order-Outwards-Blue64.png" alt="GR Outwards" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
                                        <span className='my-auto '>{t("GR Outwards")}</span>
                                    </h5>



                                    <div style={{ position: "relative", width: UserRole == "State" ? "150px" : "250px", marginRight: "10px" }}>
                                        <select
                                            placeholder='Choose District'
                                            value={statusofData}
                                            onChange={(e) => setstatusofData(e.target.value)}
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px 8px 8px",
                                                border: "1px solid #ccc",
                                                borderRadius: "8px",
                                                backgroundColor: "#ffffffff",
                                                fontSize: "14px",
                                                color: "#333",
                                                boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                                outline: "none"
                                            }}>
                                            <option value="">All</option>
                                            <option value="false">Pending</option>
                                            <option value="Rejected">Rejected</option>

                                        </select>
                                    </div>

                                    {
                                        UserRole == "State" && (
                                            <div style={{ position: "relative", width: "150px", marginRight: "5px" }}>
                                                <select
                                                    placeholder='Choose District'
                                                    value={SelectedDistrict}
                                                    onChange={(e) => setSelectedDistrict(e.target.value)}
                                                    style={{
                                                        width: "100%",
                                                        padding: "8px 12px 8px 8px",
                                                        border: "1px solid #ccc",
                                                        borderRadius: "8px",
                                                        backgroundColor: "#ffffffff",
                                                        fontSize: "14px",
                                                        color: "#333",
                                                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                                        outline: "none"
                                                    }}>
                                                    <option value="" >All District</option>
                                                    {
                                                        AllDistrict &&
                                                        [...new Set(AllDistrict.map(val => val.District_Marathi))].map((district, index) => {
                                                            return (
                                                                <option key={index} value={district}>{district}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        )
                                    }

                                    {
                                        UserRole == "State" && (
                                            <div style={{ position: "relative", width: "150px", marginRight: "5px" }}>
                                                <select
                                                    placeholder='Choose Taluka'
                                                    value={SelectedTalukasofDistrict}
                                                    onChange={(e) => setSelectedTalukasofDistrict(e.target.value)}
                                                    style={{
                                                        width: "100%",
                                                        padding: "8px 12px 8px 8px",
                                                        border: "1px solid #ccc",
                                                        borderRadius: "8px",
                                                        backgroundColor: "#ffffffff",
                                                        fontSize: "14px",
                                                        color: "#333",
                                                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                                        outline: "none"
                                                    }}>
                                                    <option value="" disabled>Select Taluka</option>
                                                    {
                                                        TalukasofDistrict.length > 0 &&
                                                        TalukasofDistrict.map((val, index) => {
                                                            return (
                                                                <option key={index} value={val.ULBNameMarathi}>{val.ULBNameMarathi}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        )
                                    }

                                    <div style={{ position: "relative", width: UserRole == "State" ? "150px" : "250px", marginRight: "10px" }}>
                                        <img
                                            src="/Search32.png"
                                            alt="Search Icon"
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "10px",
                                                transform: "translateY(-50%)",
                                                width: "16px",
                                                height: "16px",
                                                opacity: 0.6
                                            }}
                                        />
                                        <input
                                            type="text"
                                            placeholder={t("Search Here")}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            value={searchTerm}
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px 8px 32px",
                                                border: "1px solid #ccc",
                                                borderRadius: "8px",
                                                backgroundColor: "#f1f6fc",
                                                fontSize: "14px",
                                                color: "#333",
                                                boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                                outline: "none"
                                            }}
                                        />
                                    </div>
                                     <div className='col-4'> 

                            <button className='btn btn-success ' onClick={() => exportTableByClassToExcel(sortedBills, "AllDistrictReleaseData.xlsx")}>{t("Download Excel")}</button>
                                    </div>
                                </div> */}

                <div className="col-12 px-4 mb-4 mt-3">
                  {/* ================= ROW 1 : HEADING + DOWNLOAD ================= */}
                  <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                    <h5 className="fw-bold d-flex align-items-center m-0">
                      <img
                        src="/Work-Order-Outwards-Blue64.png"
                        alt="GR Outwards"
                        style={{
                          width: "24px",
                          height: "24px",
                          marginRight: "6px",
                        }}
                      />
                      {[24, 25, 29, 40, 41].includes(RoleID)
                        ? t("GR Status")
                        : t("GR Approval List")}
                    </h5>
                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-success"
                        onClick={() =>
                          exportTableByClassToExcel(
                            filteredBills,
                            "AllDistrictReleaseData.xlsx",
                          )
                        }
                      >
                        {t("Download Excel")}
                      </button>
                      <button
                        className="btn btn-danger"
                        onClick={() =>
                          downloadTableOnlyAsPDF(
                            "GRoutwards",
                            "GRoutwards.pdf",
                            "GR outwards Report",
                          )
                        }
                      >
                        {t("Download PDF")}
                      </button>
                    </div>
                  </div>

                    {myDepartments.length > 1 && (
  <div className="mb-2" style={{ width: "260px" }}>
    <select
      value={selectedDepartment}
      onChange={(e) => setSelectedDepartment(e.target.value)}
      style={{
        width: "100%",
        padding: "8px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#fff",
        fontSize: "16px",
      }}
    >
      <option value="">{t("Select Department")}</option>
      {myDepartments.map((d) => (
        <option key={d.id} value={d.id}>
          {d.name}
        </option>
      ))}
    </select>
  </div>
)}



                  {/* ================= ROW 2 : FILTERS + SEARCH ================= */}
                  <CommonFilters
                    UserRole={UserRole}
                    t={t}

                    // {/* Data Type */}
                    showDataType={UserRole === "State" && RoleID == 29}
                    typeofData={typeofData}
                    settypeofData={settypeofData}

                    // {/* Status */}
                    showStatus={true}
                    statusofData={statusofData}
                    setstatusofData={setstatusofData}

                    // {/* District */}
                    showDistrict={UserRole === "State"}
                    SelectedDistrict={SelectedDistrict}
                    AllDistrict={AllDistrict}
                    openDistrict={openDistrict}
                    setOpenDistrict={setOpenDistrict}
                    isAllSelected={isAllSelected}
                    toggleAllDistricts={toggleAllDistricts}
                    handleDistrictToggle={toggleDistrict}

                    // {/* Head Code */}
                    showHeadCode={UserRole !== "State"}
                    selectedHeadCode={SelectedHeadCode}
                    setSelectedHeadCode={setSelectedHeadCode}
                    headCodeOptions={[
                      ...new Set(
                        technicalInwards
                          ?.map((item) => item.HeadCode)
                          .filter(Boolean)
                      ),
                    ]}

                    // {/* Taluka */}
                    showTaluka={true}
                    SelectedTaluka={SelectedTalukasofDistrict}
                    setSelectedTaluka={setSelectedTalukasofDistrict}
                    TalukasofDistrict={TalukasofDistrict}

                    // {/* Search */}
                    showSearch={true}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                  />
                </div>
                <div className="col-12 pb-5">
                  <div
                    className="m-auto mb-3"
                    style={{
                      backgroundColor: "white",
                      padding: "40px 40px",
                      boxShadow: "0px 0px 5px 1px #E4E8EC",
                      borderRadius: "20px",
                      width: "100%",
                      maxWidth: "100%",
                      overflowX: "hidden",
                    }}
                  >
                    <div
                      className="col-12 tableDesign"
                      style={{ background: "#2C78DB", overflowX: "auto",
                      overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative" }}
                    >
                      <table
                        className="m-0 p-0 GRoutwards"
                        style={{ width: "100%", borderCollapse: "collapse" }}
                      >
                        <thead  style={{ position: "sticky",  backgroundColor: "#1976d2",
                      top: 0,
                      zIndex: 10}}>
                          <tr
                            style={{
                              color: "white",
                              border: "none",
                              height: "3rem",
                              fontSize: "18px",
                              fontWeight: "400",
                            }}
                          >
                            <th
                              style={{ minWidth: "70px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Sr.No.")}
                            </th>
                            {/* <th
                              style={{ minWidth: "100px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("GR UID")}
                            </th> */}
                            <th
                              style={{ minWidth: "100px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("GR Number")}
                            </th>
                            {UserRole === "State" && RoleID != 29 ? (
                              ""
                            ) : (
                              <th
                                style={{ minWidth: "180px", padding: "8px" }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Head Code")}
                              </th>
                            )}
                            <th
                              style={{ minWidth: "180px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Total Works Created")}
                            </th>
                            <th
                              style={{ minWidth: "100px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Approved Year")}
                            </th>
                            <th
                              style={{ minWidth: "80px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("District")}
                            </th>
                            <th
                              style={{ minWidth: "70px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Taluka")}
                            </th>
                            <th
                              style={{ minWidth: "100px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Work Amount")}
                            </th>
                            
            <th style={{ minWidth: "200px", padding: "8px" }} rowSpan={2} colSpan={1}>{t("GR Date")}</th>
                            <th
                              style={{ minWidth: "200px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("GR Copy")}
                            </th>
                            <th
                              style={{ minWidth: "180px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("GR Approval Copy")}
                            </th>
                            <th
                              style={{ minWidth: "150px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Creation Date")}
                            </th>
                            <th
                              style={{ minWidth: "150px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Uploaded By")}
                            </th>
                            <th
                              style={{ minWidth: "150px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Edited By")}
                            </th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "160px" }}
                              rowSpan={2}
                            >
                              {t("Rejected/Send Back")}
                            </th>
                            <th
                              style={{ padding: "7px 10px", minWidth: "160px" }}
                              rowSpan={2}
                            >
                              {t("Remark")}
                            </th>
                            <th style={headerStyle} colSpan={1}>
                              {t("Approved by")}
                            </th>
                            {/* {UserRole === "State" && (
                              <th
                                style={{ minWidth: "150px", padding: "8px" }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("View Edit log")}
                              </th>
                            )} */}
                            {/* <th style={{ width: "12%", textAlign: "center", border: "1px solid white" }} colSpan={1} rowSpan={2}>Details</th> */}
                          </tr>
                          <tr
                            style={{
                              color: "white",
                              border: "none",
                              height: "3rem",
                              fontSize: "18px",
                              fontWeight: "400",
                            }}
                          >
                            <th style={headerStyle}>
                              {t("RDD Section Officer")}
                            </th>
                            {/* <th style={headerStyle}>
                              {t("Deputy / Joint Secretary")}
                            </th> */}
                          </tr>
                        </thead>

                        <tbody>
                          <>
                            {displayedGRS?.length === 0 ? (
                              <tr>
                                <td
                                  colSpan="30"
                                  style={{
                                    textAlign: "center",
                                    padding: "20px",
                                    backgroundColor: "#f9f9f9",
                                  }}
                                >
                                  {t("No data available")}
                                </td>
                              </tr>
                            ) : (
                              displayedGRS?.map((proposal, index) => {
                                const bgColor =
                                  index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                return (
                                  <tr
                                    style={{
                                      backgroundColor: bgColor,
                                      fontSize: "18px",
                                      fontWeight: "400",
                                    }}
                                    key={proposal.DemandGenerationID || index}
                                  >
                                    <td
                                      style={{
                                        fontSize: "18px",
                                        padding: "5px",
                                      }}
                                    >
                                      {indexOfFirstBill + index + 1}
                                    </td>
                                    {/* <td
                                      style={{
                                        fontSize: "18px",
                                        padding: "5px",
                                      }}
                                    >
                                      {proposal.GRID}
                                    </td> */}
                                    <td
                                      style={{
                                        fontSize: "18px",
                                        padding: "5px",
                                      }}
                                    >
                                      {proposal.GRNumber}
                                    </td>
                                    {UserRole === "State" && RoleID != 29 ? (
                                      ""
                                    ) : (
                                      <td
                                        style={{
                                          fontSize: "18px",
                                          padding: "5px",
                                        }}
                                      >
                                        {proposal.HeadCode}
                                      </td>
                                    )}
                                    <td
                                      style={{
                                        fontSize: "18px",
                                        padding: "5px",
                                        textAlign: "center",
                                      }}
                                    >
                                      <button
                                        className="m-auto text-center"
                                        style={{
                                          width: "6rem",
                                          fontWeight: "650",
                                          padding: "6px 1px",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          gap: "0.1rem",
                                          background:
                                            "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
                                          color: "white",
                                          borderRadius: "8px",
                                          margin: "2px",
                                        }}
                                        onClick={() => {
                                          setgrID(proposal.GRID);
                                          setgrNumber(proposal.GRNumber); // Assuming you have this state
                                          setShowmenu(3); // Using 3 for "Works View" to avoid conflict with logs (2)
                                          fetchWorksByGR(proposal.GRNumber);
                                        }}
                                      >
                                        <img
                                          src="/view32.png"
                                          alt="view"
                                          className="me-1"
                                          style={{
                                            width: "12px",
                                            height: "12px",
                                          }}
                                        />
                                        {t("View Works")}
                                      </button>
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "18px",
                                        padding: "5px",
                                      }}
                                    >
                                      {proposal.ProposalYear}
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "18px",
                                        padding: "5px",
                                      }}
                                    >
                                      {proposal.ZillaParishad}
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "18px",
                                        padding: "5px",
                                      }}
                                    >
                                      {proposal.Taluka}
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "18px",
                                        padding: "5px",
                                      }}
                                    >
                                      {/* {proposal.GRAmount} */}
                                      {Number(proposal.GRAmount).toLocaleString("en-IN")}
                                    </td>
                                     <td style={{ fontSize: "18px", padding: "8px" }}>{new Date(proposal.GRDate).toLocaleDateString(
                                        "en-IN",
                                      )}</td>
                                    {/* <td  style={{ fontSize: "12px", padding: "5px" }}>{proposal.GRCopy}</td>
                                                    <td  style={{ fontSize: "12px", padding: "5px" }}>{proposal.GRDraftCopy}</td> */}
                              <td style={{ padding: '8px' }}>
  {proposal.GRUploadFile || proposal.GRCopy ? (
    <>
      {proposal.GRUploadFile && (
        <div>
          <a
            href={`${apiurl}/ProposalFile/${proposal.GRUploadFile}`}
            target="_blank"
            rel="noreferrer"
          >
            {proposal.GRUploadFile}
          </a>
        </div>
      )}

      {proposal.GRCopy && (
        <div>
          <a
            href={`${apiurl}/ProjectDocsImages/${proposal.GRCopy}`}
            target="_blank"
            rel="noreferrer"
          >
            {proposal.GRCopy}
          </a>
        </div>
      )}
    </>
  ) : (
    <p className="text-danger my-auto fw-bold">
      {t("No File")}
    </p>
  )}
</td>
                                    <td style={{ padding: "8px" }}>
                                      {proposal.GRDraftCopy ? (
                                        <a
                                          href={`${apiurl}/GRDraftCopy/${proposal.GRDraftCopy}`}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          {proposal.GRDraftCopy}
                                        </a>
                                      ) : (
                                        <p className="text-danger my-auto fw-bold">
                                          {t("No File")}
                                        </p>
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "18px",
                                        padding: "5px",
                                      }}
                                    >
                                      {new Date(proposal.Date).toLocaleString(
                                        "en-IN",
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "18px",
                                        padding: "5px",
                                      }}
                                    >
                                      {proposal.Uploadedby == null
                                        ? "--"
                                        : proposal.Uploadedby}
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "18px",
                                        padding: "5px",
                                      }}
                                    >
                                      {proposal.EditedBy ? (
                                        <p className="text-black my-auto fw-bold">
                                          {proposal.EditedBy}
                                        </p>
                                      ) : (
                                        <p className="text-danger my-auto fw-bold">
                                          {t("No One")}
                                        </p>
                                      )}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {proposal.GRStatus === "Pending"
                                        ? "No"
                                        : proposal.GRStatus}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {proposal.Remark || "--"}
                                    </td>
                                    <td
                                      style={{
                                        padding: "8px",
                                        textAlign: "center",
                                      }}
                                    >
                                      {proposal.Approve2 === "true" ? (
                                        <div
                                          className="m-auto"
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                            borderRadius: "6px",
                                            backgroundColor: "#16C60C",
                                            border: "none",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            fontSize: "18px",
                                            color: "white",
                                            boxShadow:
                                              "0 2px 4px rgba(0,0,0,0.1)",
                                          }}
                                        >
                                          ✓
                                        </div>
                                      ) : proposal.Approve2 === "false" ? (
                                        <div
                                          className="m-auto"
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                            borderRadius: "6px",
                                            backgroundColor: "#dc2626",
                                            border: "none",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            fontSize: "18px",
                                            color: "white",
                                            boxShadow:
                                              "0 2px 4px rgba(0,0,0,0.1)",
                                          }}
                                        >
                                          ✕
                                        </div>
                                      ) : (
                                        "-"
                                      )}
                                    </td>
                                    {/* <td
                                      style={{
                                        padding: "8px",
                                        textAlign: "center",
                                      }}
                                    >
                                      {proposal.Approve3 === "true" ? (
                                        <div
                                          className="m-auto"
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                            borderRadius: "6px",
                                            backgroundColor: "#16C60C",
                                            border: "none",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            fontSize: "18px",
                                            color: "white",
                                            boxShadow:
                                              "0 2px 4px rgba(0,0,0,0.1)",
                                          }}
                                        >
                                          ✓
                                        </div>
                                      ) : proposal.Approve3 === "false" ? (
                                        <div
                                          className="m-auto"
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                            borderRadius: "6px",
                                            backgroundColor: "#dc2626",
                                            border: "none",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            fontSize: "18px",
                                            color: "white",
                                            boxShadow:
                                              "0 2px 4px rgba(0,0,0,0.1)",
                                          }}
                                        >
                                          ✕
                                        </div>
                                      ) : (
                                        "-"
                                      )}
                                    </td> */}
{/* 
                                    {UserRole === "State" && (
                                      <td
                                        style={{
                                          fontSize: "12px",
                                          padding: "5px",
                                        }}
                                      >
                                        <button
                                          className="btn btn-success btn-sm"
                                          onClick={() => {
                                            setShowmenu(2);
                                            logofgridfetchfunction(
                                              proposal.GRID,
                                              proposal.GRNumber,
                                            );
                                          }}
                                        >
                                          {t("View")}
                                        </button>
                                      </td>
                                    )} */}

                                    {/* <td style={{ padding: '8px' }}>{proposal.Proposal_copy}</td> */}
                                    {/* <td>
                                                                <button
                                                                    className='m-auto'
                                                                    onClick={() => selectedBillDetails(proposal.GRID)}
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        background: "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                                                        color: 'white',
                                                                        border: 'none',
                                                                        padding: '8px 20px',
                                                                        borderRadius: '4px',
                                                                        fontSize: "12px",
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: 'center'
                                                                    }}
                                                                >
                                                                    <img src="/view32.png" alt="view" className='me-1' style={{ width: "12px", height: "12px" }} />
                                                                    View
                                                                </button>
                                                            </td> */}
                                  </tr>
                                );
                              })
                            )}
                            <tr
                              style={{
                                fontWeight: "600",
                                backgroundColor: "#f0f0f0",
                                fontSize: "18px",
                              }}
                            >
                              <td
                                colSpan={
                                  UserRole === "State" && RoleID != 29 ? 6 : 7
                                }
                                style={{ textAlign: "right", padding: "8px" }}
                              >
                                {t("Page Total")}
                              </td>

                              <td style={{ padding: "8px" }}>
                                ₹{" "}
                                {pagetotalProposalAmount.toLocaleString(
                                  "en-IN",
                                )}
                              </td>

                              {/* remaining columns */}
                              <td colSpan={UserRole === "State" ? 19 : 20}></td>
                            </tr>
                            <tr
                              style={{
                                fontWeight: "600",
                                backgroundColor: "#f0f0f0",
                                fontSize: "18px",
                              }}
                            >
                              <td
                                colSpan={
                                  UserRole === "State" && RoleID != 29 ? 6 : 7
                                }
                                style={{ textAlign: "right", padding: "8px" }}
                              >
                                {t("Gross Total")}
                              </td>

                              <td style={{ padding: "8px", minWidth: "240px",
      width: "260px",
      whiteSpace: "nowrap",
      textAlign:"center",  }}>
                                ₹ {totalProposalAmount.toLocaleString("en-IN")}
                              </td>

                              {/* remaining columns */}
                              <td colSpan={UserRole === "State" ? 19 : 20}></td>
                            </tr>
                          </>
                        </tbody>
                      </table>
                    </div>
                    <div className="col-12 mt-4">
                      <div className="row">
                        <div className="col-6">
                          <p
                            className="text-gray-600"
                            style={{ fontSize: "18px", margin: 0 }}
                          >
                            {t("Showing")} {indexOfFirstBill + 1} {t("to")}{" "}
                            {Math.min(indexOfLastBill, filteredBills?.length)}{" "}
                            {t("of")} {filteredBills?.length} {t("entries")}
                          </p>
                        </div>
                        <div
                          className="col-6 text-end"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "end",
                          }}
                        >
                          <GooglePagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={setCurrentPage}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {selectedProposal && (
                <div
                  onClick={() => setSelectedProposal(null)}
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0, 0, 0, 0.84)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999,
                  }}
                >
                  <div
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      backgroundColor: "white",
                      padding: "40px 40px",
                      borderRadius: "20px",
                      width: "50%",
                      maxHeight: "90vh",
                      overflow: "hidden",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
                      position: "relative",
                    }}
                  >
                    <div className="col-12">
                      <div className="col-12  mb-3">
                        <div className="row">
                          <div className="col-6">
                            <h5>GR Details</h5>
                          </div>

                          <div
                            className="col-6"
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <button
                              onClick={() => setSelectedProposal(null)}
                              style={{
                                width: "32px",
                                height: "32px",
                                borderRadius: "50%",
                                backgroundColor: "red",
                                border: "none",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                fontSize: "24px",
                                fontWeight: "bold",
                                color: "white",
                                lineHeight: 1,
                              }}
                            >
                              ×
                            </button>
                          </div>
                        </div>
                      </div>

                      <div
                        className="col-12"
                        style={{
                          height: "59vh",
                          overflowX: "hidden",
                          overflowY: "scroll",
                          scrollBehavior: "smooth",
                        }}
                      >
                        <table
                          style={{
                            width: "100%",
                            height: "100%",
                            borderCollapse: "collapse",
                          }}
                        >
                          <tbody>
                            {Object.entries(selectedProposal).map(
                              ([key, value], index) => (
                                <>
                                  <tr
                                    key={key}
                                    style={{
                                      backgroundColor:
                                        index % 2 === 0 ? "#2B75D5" : "#cce0f9",
                                      border: "1px solid #cce0f9",
                                    }}
                                  >
                                    <td
                                      style={{
                                        fontWeight: "bold",
                                        padding: "8px",
                                        width: "40%",
                                        backgroundColor: "#2B75D5",
                                        color: "white",
                                        border: "1px solid #cce0f9",
                                      }}
                                    >
                                      {key}
                                    </td>
                                    <td
                                      style={{
                                        padding: "8px",
                                        color: "black",
                                        backgroundColor:
                                          index % 2 === 0
                                            ? "#E3EBF5"
                                            : "#D0DEF1",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                        maxWidth: "160px",
                                      }}
                                    >
                                      {/* Handle Upload Bill Copy link */}
                                      {key === "GR Copy" && value ? (
                                        <a
                                          href={`${apiurl}/ProjectDocsImages/${value}`}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          {value}
                                        </a>
                                      ) : key === "GR Approval Copy" &&
                                        value ? (
                                        <a
                                          href={`${apiurl}/GRDraftCopy/${value}`}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          {value}
                                        </a>
                                      ) : value === null || value === "" ? (
                                        "-"
                                      ) : (
                                        value.toString()
                                      )}
                                    </td>
                                  </tr>
                                </>
                              ),
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          {loading && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(255,255,255,0.4)",
                backdropFilter: "blur(2px)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div className="Adminloader"></div>
            </div>
          )}
        </div>
      )}

      {showmenu == 2 && (
        <div
          className="col-12 pb-5"
          style={{
            backgroundColor: "#EFF3F8",
            height: "90vh",
            overflowX: "hidden",
            overflowY: "scroll",
            position: "relative",
          }}
        >
          <div
            style={{
              filter: loading ? "blur(4px)" : "none",
              pointerEvents: loading ? "none" : "auto",
              transition: "0.2s ease",
            }}
          >
            <div className="col-11 m-auto">
              <div className="col-12 ">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                    padding: "10px 4rem",
                  }}
                >
                  <button
                    className="btn btn-danger px-3 py-1"
                    onClick={() => {
                      setgrID();
                      setShowmenu(1);
                      setgrlogData([]);
                    }}
                  >
                    {t("Back")}
                  </button>

                  <h5 className="my-auto fw-bold">
                    <img
                      src="/Work-Order-Outwards-Blue64.png"
                      alt="GR Outwards"
                      style={{ width: "24px", height: "24px" }}
                      className="my-auto me-1"
                    />
                    <span className="my-auto ">
                      GR- {grId} {t("Logs")}
                    </span>
                  </h5>
                </div>

                <div className="col-12 pb-5">
                  <div
                    className="m-auto mb-3"
                    style={{
                      backgroundColor: "white",
                      padding: "40px 40px",
                      boxShadow: "0px 0px 5px 1px #E4E8EC",
                      borderRadius: "20px",
                      width: "100%",
                      maxWidth: "100%",
                      overflowX: "hidden",
                    }}
                  >
                    <div
                      className="col-12 tableDesign"
                      style={{ background: "#2C78DB", overflowX: "scroll" }}
                    >
                      <table
                        className="m-0 p-0"
                        style={{ width: "100%", borderCollapse: "collapse" }}
                      >
                        <thead>
                          <tr
                            style={{
                              color: "white",
                              border: "none",
                              height: "3rem",
                              fontSize: "12px",
                              fontWeight: "400",
                            }}
                          >
                            <th style={{ minWidth: "70px", padding: "8px" }}>
                              Sr.No.
                            </th>
                            <th style={{ minWidth: "100px", padding: "8px" }}>
                              Action
                            </th>
                            <th style={{ minWidth: "100px", padding: "8px" }}>
                              Entity ID
                            </th>
                            <th style={{ minWidth: "100px", padding: "8px" }}>
                              Entity Type
                            </th>
                            <th style={{ minWidth: "100px", padding: "8px" }}>
                              Performed By
                            </th>
                            <th style={{ minWidth: "100px", padding: "8px" }}>
                              Role
                            </th>
                            <th style={{ minWidth: "100px", padding: "8px" }}>
                              Date
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {currentlogBills?.length === 0 ? (
                            <tr>
                              <td
                                colSpan="30"
                                style={{
                                  textAlign: "center",
                                  padding: "20px",
                                  backgroundColor: "#f9f9f9",
                                }}
                              >
                                No data available
                              </td>
                            </tr>
                          ) : (
                            currentlogBills.map((proposal, index) => {
                              const bgColor =
                                index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";

                              return (
                                <tr
                                  style={{
                                    backgroundColor: bgColor,
                                    fontSize: "12px",
                                    fontWeight: "400",
                                  }}
                                  key={index}
                                >
                                  <td
                                    style={{ fontSize: "12px", padding: "5px" }}
                                  >
                                    {indexOfFirstlogBill + index + 1}
                                  </td>
                                  <td
                                    style={{ fontSize: "12px", padding: "5px" }}
                                  >
                                    {proposal.ActionType}
                                  </td>
                                  <td
                                    style={{ fontSize: "12px", padding: "5px" }}
                                  >
                                    {proposal.EntityID}
                                  </td>
                                  <td
                                    style={{ fontSize: "12px", padding: "5px" }}
                                  >
                                    {proposal.EntityType}
                                  </td>
                                  <td
                                    style={{ fontSize: "12px", padding: "5px" }}
                                  >
                                    {proposal.PerformedBy}
                                  </td>
                                  <td
                                    style={{ fontSize: "12px", padding: "5px" }}
                                  >
                                    {proposal.Role}
                                  </td>
                                  <td
                                    style={{ fontSize: "12px", padding: "5px" }}
                                  >
                                    {new Date(
                                      new Date(
                                        proposal.ActionTimestamp,
                                      ).getTime() +
                                        5.5 * 60 * 60 * 1000,
                                    ).toLocaleString("en-IN", {
                                      day: "2-digit",
                                      month: "2-digit",
                                      year: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      second: "2-digit",
                                      hour12: true,
                                    })}
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="col-12 mt-4">
                      <div className="row">
                        <div className="col-6">
                          <p
                            className="text-gray-600"
                            style={{ fontSize: "18px", margin: 0 }}
                          >
                            Showing {indexOfFirstlogBill + 1} to{" "}
                            {Math.min(
                              indexOfFirstlogBill + 1,
                              grlogData?.length,
                            )}{" "}
                            of {grlogData?.length} entries
                          </p>
                        </div>
                        <div
                          className="col-6 text-end"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "end",
                          }}
                        >
                          <button
                            onClick={() => setcurrentlogpage(1)}
                            disabled={currentlogPage === 1}
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              border: "1px solid lightgrey",
                              cursor: "pointer",
                              fontSize: "24px",
                            }}
                          >
                            &laquo;
                          </button>
                          <button
                            onClick={() =>
                              setcurrentlogpage(currentlogPage - 1)
                            }
                            disabled={currentlogPage === 1}
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              border: "1px solid lightgrey",
                              cursor: "pointer",
                              fontSize: "24px",
                              borderLeft: "none",
                            }}
                          >
                            &lt;
                          </button>
                          <button
                            style={{
                              background:
                                "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
                              color: "white",
                              cursor: "pointer",
                              fontSize: "24px",
                              width: "3rem",
                              border: "1px solid lightgrey",
                              borderLeft: "none",
                            }}
                          >
                            {currentlogPage}
                          </button>
                          <button
                            onClick={() =>
                              setcurrentlogpage(currentlogPage + 1)
                            }
                            disabled={currentlogPage === totallogPages}
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              border: "1px solid lightgrey",
                              cursor: "pointer",
                              fontSize: "24px",
                              borderLeft: "none",
                            }}
                          >
                            &gt;
                          </button>
                          <button
                            onClick={() => setcurrentlogpage(totallogPages)}
                            disabled={currentlogPage === totallogPages}
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              border: "1px solid lightgrey",
                              cursor: "pointer",
                              fontSize: "24px",
                              borderLeft: "none",
                            }}
                          >
                            &raquo;
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {loading && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(255,255,255,0.4)",
                backdropFilter: "blur(2px)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div className="Adminloader"></div>
            </div>
          )}
        </div>
      )}

      {showmenu == 3 && (
        <div
          className="col-12 pb-5"
          style={{
            backgroundColor: "#EFF3F8",
            height: "90vh",
            overflowX: "hidden",
            overflowY: "scroll",
            position: "relative",
          }}
        >
          <div
            style={{
              filter: loading ? "blur(4px)" : "none",
              pointerEvents: loading ? "none" : "auto",
              transition: "0.2s ease",
            }}
          >
            <div className="col-11 m-auto">
              <div className="col-12 ">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                    padding: "10px 4rem",
                  }}
                >
                  <button
                    className="btn btn-danger px-3 py-1"
                    onClick={() => {
                      setShowmenu(1);
                      setWorksData([]);
                    }}
                  >
                    {t("Back")}
                  </button>
                  <h5 className="my-auto fw-bold">
                    <img
                      src="/Work-Order-Outwards-Blue64.png"
                      alt="Works"
                      style={{ width: "24px", height: "24px" }}
                      className="my-auto me-1"
                    />
                    <span className="my-auto ">
                      {t("Works under GR")} {grNumber}
                    </span>
                  </h5>
                </div>

                <div className="col-12 pb-5">
                  <div
                    className="m-auto mb-3"
                    style={{
                      backgroundColor: "white",
                      padding: "30px",
                      boxShadow: "0px 0px 5px 1px #E4E8EC",
                      borderRadius: "20px",
                      width: "100%",
                    }}
                  >
                    <div
                      className="col-12 tableDesign"
                      style={{ background: "#2C78DB", overflowX: "auto" }}
                    >
                      <table
                        className="m-0 p-0"
                        style={{ width: "100%", borderCollapse: "collapse" }}
                      >
                        <thead>
                          <tr
                            style={{
                              color: "white",
                              border: "none",
                              height: "3rem",
                              fontSize: "18px",
                            }}
                          >
                            <th style={{ padding: "8px" }}>{t("Sr.No.")}</th>
                            <th style={{ minWidth: "150px", padding: "8px" }}>
                              {t("Work Name")}
                            </th>
                            <th style={{ minWidth: "100px", padding: "8px" }}>
                              {t("Job ID")}
                            </th>
                            <th style={{ minWidth: "120px", padding: "8px" }}>
                              {t("Class of Work")}
                            </th>
                            <th style={{ minWidth: "100px", padding: "8px" }}>
                              {t("GR Date")}
                            </th>
                              <th style={{ minWidth: "100px", padding: "8px" }}>
                              {t("GR Amount")}
                            </th>
                            <th style={{ minWidth: "100px", padding: "8px" }}>
                              {t("Work Unique ID")}
                            </th>
                            <th style={{ minWidth: "100px", padding: "8px" }}>
                              {t("GR Copy")}
                            </th>
                            <th style={{ minWidth: "100px", padding: "8px" }}>
                              {t("Remark")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {worksData?.length === 0 ? (
                            <tr>
                              <td
                                colSpan="8"
                                style={{
                                  textAlign: "center",
                                  padding: "20px",
                                  backgroundColor: "#f9f9f9",
                                }}
                              >
                                {t("No works found for this GR")}
                              </td>
                            </tr>
                          ) : (
                worksData.map((work, index) => (
                              <tr
                               key={index}
                                style={{
                                  backgroundColor:
                                    index % 2 === 0 ? "#E5F4FB" : "#CFE4F1",
                                  fontSize: "18px",
                                }}
                              >
                                <td style={{ padding: "8px" }}>{index + 1}</td>
                                <td style={{ padding: "8px" }}>
                                  {work.Work_name}
                                </td>
                                <td style={{ padding: "8px" }}>
                                  {work.JOB_ID}
                                </td>
                                <td style={{ padding: "8px" }}>
                                  {work.classOfWork}
                                </td>
                                 <td style={{ padding: "8px" }}>
              {work.GRDate && !isNaN(new Date(work.GRDate).getTime())
                  ? new Date(work.GRDate).toLocaleDateString("en-IN")
                  : "-"}
                    </td>
      
                              <td style={{ padding: "8px" }}>
                                                        {work.ProposalAmount}
                                                      </td>
                                <td style={{ padding: "8px" }}>
                                  {work.workuniqueid}
                                </td>
                                 <td style={{ padding: '8px' }}>
                                {work.GRUploadFile || work.GRCopy ? (
                                  <>
                                    {work.GRUploadFile && (
                                      <div>
                                        <a
                                          href={`${apiurl}/ProposalFile/${work.GRUploadFile}`}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          {work.GRUploadFile}
                                        </a>
                                      </div>
                                    )}

                                    {work.GRCopy && (
                                      <div>
                                        <a
                                          href={`${apiurl}/ProjectDocsImages/${work.GRCopy}`}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          {work.GRCopy}
                                        </a>
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <p className="text-danger my-auto fw-bold">
                                    {t("No File")}
                                  </p>
                                )}
                              </td>
                                <td style={{ padding: "8px" }}>
                                  {work.workRemark}
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GrOutwards;



//--> old code
// import React, { useState, useEffect, useContext } from "react";
// import AdminContext from "../../StateContext/Application";
// import { apiurl } from "../../../../path";
// import { useLanguage } from "../../../../lang/langcontext/LanguageContext";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import GooglePagination from "../../styles/GooglePagination";
// import { formatDateTime, formatDate } from '../../../../utils/DateFormat';

// const GrOutwards = () => {
//   const { language, toggleLanguage, t } = useLanguage();
//   const context = useContext(AdminContext);
//   const { GetAllProjectList, GetBudgetHeadInfo, Usermenu, GetWorksByGR } =
//     context;

//   const [worksData, setWorksData] = useState([]);

//   const fetchWorksByGR = async (grid) => {
//     setloading(true);
//     try {
//       let data = await GetWorksByGR(grid);
//       if (data.status) {
//         setWorksData(data.message);
//       }
//     } catch (error) {
//       console.error("Error fetching works:", error);
//     } finally {
//       setloading(false);
//     }
//   };

//   console.log("worksData: ", worksData);

//   const [project, setProjectList] = useState([]);
//   const [proposallist, setProposalList] = useState([]);
//   const [filteredBills, setFilteredBills] = useState([]);
//   const [technicalInwards, setTechnicalInwards] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const budgetEstimation = proposallist;
//   const billsPerPage = 10;
//   const [selectedProposal, setSelectedProposal] = useState(null);
//   const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
//   const indexOfLastBill = currentPage * billsPerPage;
//   const indexOfFirstBill = indexOfLastBill - billsPerPage;
//   const sortedBills = Array.isArray(filteredBills)
//     ? filteredBills
//         .slice() // ✅ prevent state mutation
//         .sort((a, b) => new Date(b.Date) - new Date(a.Date))
//     : [];
//   const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);
//   // const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

//   const [exportingPDF, setExportingPDF] = useState(false);

//   const displayedGRS = exportingPDF ? filteredBills : currentBills;
//   const [searchTerm, setSearchTerm] = useState("");
//   const [statusofData, setstatusofData] = useState("");

//   const [showmenu, setShowmenu] = useState(1);
//   const [grId, setgrID] = useState("");
//   const [grNumber, setgrNumber] = useState("");
//   const [grlogData, setgrlogData] = useState([]);
//   const [filteredlogBills, setFilteredlogBills] = useState([]);
//   const [currentlogPage, setcurrentlogpage] = useState(1);
//   const totallogPages = Math.ceil(filteredlogBills?.length / billsPerPage);
//   const indexOfLastlogBill = currentlogPage * billsPerPage;
//   const indexOfFirstlogBill = indexOfLastlogBill - billsPerPage;
//   const currentlogBills = filteredlogBills?.slice(
//     indexOfFirstlogBill,
//     indexOfLastlogBill,
//   );
//   const [UserRole, setUserRole] = useState("");
//   const [AllDistrict, setAllDistrict] = useState([]);
//   const [TalukasofDistrict, setTalukasofDistrict] = useState([]);
//   const [SelectedDistrict, setSelectedDistrict] = useState([]);
//   const [SelectedHeadCode, setSelectedHeadCode] = useState("");
//   const [SelectedTalukasofDistrict, setSelectedTalukasofDistrict] =
//     useState("");
//   const [openDistrict, setOpenDistrict] = useState(false);
//   const [RoleID, setroleID] = useState(null);
//   const [typeofData, settypeofData] = useState("District");
//   const [loading, setloading] = useState(false);

//   console.log("filteredlogBills: ", filteredlogBills);

//   const headerStyle = {
//     padding: "12px 16px",
//     whiteSpace: "nowrap",
//     borderRight: "1px solid #e0e0e0",
//     textTransform: "capitalize",
//   };

//   const getProjectList = async () => {
//     let data = await GetAllProjectList();
//     const { status, message, Tabletype, District } = data;
//     if (status) {
//       let resultData = message;
//       if (Tabletype != "State") {
//         resultData = message.filter((item) => item.ZillaParishad == District);
//       }
//       setProjectList(resultData);
//       setTechnicalInwards(resultData);
//       setProposalList(resultData);
//       setUserRole(Tabletype);
//     } else {
//       alert(message);
//     }
//   };

//   const getmenu = async () => {
//     try {
//       const data = await Usermenu();
//       if (!data || typeof data !== "object") {
//         console.error("Invalid data:", data);
//         return;
//       }
//       const roleID = data?.Data?.RoleID;
//       setroleID(roleID);
//       console.log("sffdsf", data?.Data);
//     } catch (error) {
//       console.error("Error in AdminNavbar getmenu:", error);
//     }
//   };
//   useEffect(() => {
//     getProjectList();
//     getmenu();
//   }, []);

//   useEffect(() => {
//     setSelectedTalukasofDistrict("");
//     setSelectedHeadCode("");
//   }, [SelectedDistrict]);

//   //     useEffect(() => {
//   //     let filtered = [...technicalInwards];

//   //     // 🔹 Filter by District
//   //     if (SelectedDistrict) {
//   //         filtered = filtered.filter(
//   //             item => item.ZillaParishad === SelectedDistrict
//   //         );
//   //     }

//   //     // 🔹 Filter by Taluka
//   //     if (SelectedTalukasofDistrict) {
//   //         filtered = filtered.filter(
//   //             item => item.Taluka === SelectedTalukasofDistrict
//   //         );
//   //     }

//   //     // 🔹 Filter by Status
//   //     if (statusofData !== "") {

//   //         if (statusofData === "false") {
//   //             // Pending / Not approved
//   //             filtered = filtered.filter(
//   //                 item =>
//   //                     item.GRStatus !== "Rejected" &&
//   //                     (
//   //                         item.Approve1 === "false" ||
//   //                         item.Approve2 === "false" ||
//   //                         item.Approve3 === "false"
//   //                     )
//   //             );
//   //         }
//   //         else if (statusofData === "Rejected") {
//   //             filtered = filtered.filter(
//   //                 item => item.GRStatus === "Rejected"
//   //             );
//   //         }
//   //         else {
//   //             filtered = filtered.filter(
//   //                 item => item.GRStatus === statusofData
//   //             );
//   //         }
//   //     }

//   //     // 🔹 Search filter
//   //     if (searchTerm.trim() !== "") {
//   //         const lower = searchTerm.toLowerCase();
//   //         filtered = filtered.filter(item =>
//   //             Object.values(item).some(val =>
//   //                 (val ?? "")
//   //                     .toString()
//   //                     .toLowerCase()
//   //                     .includes(lower)
//   //             )
//   //         );
//   //     }

//   //     setFilteredBills(filtered);
//   //     setCurrentPage(1);

//   // }, [
//   //     technicalInwards,
//   //     SelectedDistrict,
//   //     SelectedTalukasofDistrict,
//   //     statusofData,
//   //     searchTerm
//   // ]);
//   useEffect(() => {
//     let filtered = [...technicalInwards];
//     if (typeofData === "District" && RoleID === 29) {
//       filtered = filtered.filter(
//         (item) =>
//           item.HeadCode ===
//           "3054-2419(Roads and bridge repair maintenance program)",
//       );
//       console.log("filtered Date 3054", filtered);
//     } else if (typeofData === "State" && RoleID === 29) {
//       filtered = filtered.filter(
//         (item) => item.HeadCode === "2515-1238(MLA Representative)",
//       );
//     }
//     // 🔹 Filter by District (MULTI)
//     if (SelectedDistrict && SelectedDistrict.length > 0) {
//       filtered = filtered.filter((item) =>
//         SelectedDistrict.includes(item.ZillaParishad),
//       );
//     }

//     // 🔹 Filter by Taluka (single select – unchanged)
//     if (SelectedTalukasofDistrict) {
//       filtered = filtered.filter(
//         (item) => item.Taluka === SelectedTalukasofDistrict,
//       );
//     }

//     // 🔹 Filter by Head Code
//     if (SelectedHeadCode) {
//       filtered = filtered.filter(
//         item => item.HeadCode === SelectedHeadCode
//       );
//     }

//     // 🔹 Filter by Status
//     if (statusofData !== "") {
//       if (statusofData === "false") {
//         // Pending / Not approved
//         filtered = filtered.filter(
//           (item) =>
//             item.GRStatus !== "Rejected" &&
//             (item.Approve1 === "false" ||
//               item.Approve2 === "false" ||
//               item.Approve3 === "false"),
//         );
//       } else if (statusofData === "Rejected") {
//         filtered = filtered.filter((item) => item.GRStatus === "Rejected");
//       } else if (statusofData === "Approved") {
//         // ✅ Added block
//         filtered = filtered.filter(
//           (item) =>
//             item.Approve1 === "true" &&
//             item.Approve2 === "true" &&
//             item.Approve3 === "true",
//         );
//       } else {
//         filtered = filtered.filter((item) => item.GRStatus === statusofData);
//       }
//     }

//     // 🔹 Search filter
//     if (searchTerm.trim() !== "") {
//       const lower = searchTerm.toLowerCase();
//       filtered = filtered.filter((item) =>
//         Object.values(item).some((val) =>
//           (val ?? "").toString().toLowerCase().includes(lower),
//         ),
//       );
//     }

//     setFilteredBills(filtered);
//     setCurrentPage(1);
//   }, [
//     technicalInwards,
//     SelectedDistrict, // array
//     SelectedTalukasofDistrict,
//     statusofData,
//     searchTerm,
//     typeofData,
//      SelectedHeadCode,
//   ]);
//   const selectedBillDetails = (BillID) => {
//     const result = budgetEstimation
//       .filter((item) => item.GRID == BillID)
//       .map((item) => ({
//         "GR UID": item.GRID,
//         "GR Number": item.GRNumber,
//         "Head Code": item.HeadCode,
//         "Proposal Year": item.ProposalYear,
//         District: item.ZillaParishad,
//         Taluka: item.Taluka,
//         "Work Amount": item.GRAmount,
//         "GR Copy": item.GRCopy,
//         "GR Approval Copy": item.GRDraftCopy,
//         Date: new Date(item.Date).toLocaleString(),
//       }));

//     console.log("------------------", result);
//     setSelectedProposal(result[0]);
//   };

//   const logofgridfetchfunction = async (id, idNumber) => {
//     setgrID(id);
//     try {
//       let obj = {
//         GRID: id,
//         GRnumber: idNumber,
//       };

//       let res = await GetBudgetHeadInfo(
//         obj,
//         "GetAlllogofparticulardatafromGrID",
//       );
//       console.log(res);
//       setgrlogData(res);
//       setFilteredlogBills(res);
//     } catch (err) {
//       alert("Internal Server Error");
//     }
//   };

//   const FetchGramPanachayatInfo = async () => {
//     try {
//       let res = await GetBudgetHeadInfo("null", "AllDistrict");
//       // console.log("Data i get:: ", res);
//       setAllDistrict(res);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   useEffect(() => {
//     FetchGramPanachayatInfo();
//   }, []);
//   useEffect(() => {
//     if (SelectedDistrict?.length > 0) {
//       console.log("Selected Districts:", SelectedDistrict);

//       const res = AllDistrict.filter((item) =>
//         SelectedDistrict.includes(item.District_Marathi),
//       );

//       if (SelectedDistrict.length > 1) {
//         setTalukasofDistrict([]);
//       } else {
//         setTalukasofDistrict(res);
//       }
//     } else {
//       setSelectedDistrict("");
//       setSelectedTalukasofDistrict("");
//       setTalukasofDistrict([]);
//       setSelectedHeadCode("");
//     }
//   }, [SelectedDistrict]);

//   const totalProposalAmount = filteredBills?.reduce((sum, item) => {
//     const amount = Number(item?.GRAmount);
//     return sum + (isNaN(amount) ? 0 : amount);
//   }, 0);
//     const pagetotalProposalAmount = currentBills?.reduce((sum, item) => {
//     const amount = Number(item?.GRAmount);
//     return sum + (isNaN(amount) ? 0 : amount);
//   }, 0);

//   const exportTableByClassToExcel = async (
//     filteredBills,
//     UserRole,
//     filename = "GR_Report.xlsx",
//   ) => {
//     if (!Array.isArray(filteredBills) || filteredBills.length === 0) {
//       alert("No data available");
//       return;
//     }
//     setloading(true);
//     await new Promise((resolve) => setTimeout(resolve, 1000));
//     try {
//       let totalGRAmount = 0;

//       const excelData = filteredBills.map((proposal, index) => {
//         const grAmount = Number(proposal.GRAmount || 0);
//         totalGRAmount += isNaN(grAmount) ? 0 : grAmount;

//         return {
//           "Sr.No": index + 1,
//           "GR UID": proposal.GRID || "-",
//           "GR Number": proposal.GRNumber || "-",
//           "Head Code": proposal.HeadCode || "-",
//           "Work Name": proposal.Work_name || "-",
//           "Approved Year": proposal.ProposalYear || "-",
//           District: proposal.ZillaParishad || "-",
//           Taluka: proposal.Taluka || "-",
//           "Work Amount": grAmount,

//           "GR Copy": proposal.GRCopy || "No File",
//           "GR Approval Copy": proposal.GRDraftCopy || "No File",

//           "Creation Date": proposal.Date
//             ? formatDateTime(proposal.Date)
//             : "-",

//           "Uploaded By": proposal.Uploadedby || "--",
//           "Edited By": proposal.EditedBy || "No One",

//           "Rejected / Send Back":
//             proposal.GRStatus === "Pending" ? "No" : proposal.GRStatus || "-",

//           Remark: proposal.Remark || "--",

//           "RDD Section Officer":
//             proposal.Approve2 === "true"
//               ? "✓"
//               : proposal.Approve2 === "false"
//                 ? "✕"
//                 : "-",

//           "Deputy / Joint Secretary":
//             proposal.Approve3 === "true"
//               ? "✓"
//               : proposal.Approve3 === "false"
//                 ? "✕"
//                 : "-",
//         };
//       });

//       /* ---- TOTAL ROW ---- */
//       excelData.push({
//         "Sr.No": "",
//         "GR UID": "",
//         "GR Number": "",
//         "Head Code": "",
//         "Work Name": "",
//         "Approved Year": "",
//         District: "",
//         Taluka: "TOTAL AMOUNT",
//         "Work Amount": totalGRAmount,

//         "GR Copy": "",
//         "GR Approval Copy": "",
//         "Creation Date": "",
//         "Uploaded By": "",
//         "Edited By": "",
//         "Rejected / Send Back": "",
//         Remark: "",
//         "RDD Section Officer": "",
//         "Deputy / Joint Secretary": "",
//       });

//       const worksheet = XLSX.utils.json_to_sheet(excelData);

//       worksheet["!cols"] = Object.keys(excelData[0]).map(() => ({ wch: 24 }));
//       worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };

//       // Autofilter only on data rows (exclude TOTAL)
//       worksheet["!autofilter"] = {
//         ref: XLSX.utils.encode_range({
//           s: { r: 0, c: 0 },
//           e: {
//             r: excelData.length - 2,
//             c: Object.keys(excelData[0]).length - 1,
//           },
//         }),
//       };

//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "GR Report");
//       XLSX.writeFile(workbook, filename);
//     } catch (error) {
//       console.error("Excel Export Error:", error);
//     } finally {
//       setloading(false); // ✅ ALWAYS stop loader
//     }
//   };

//   const allDistricts = [
//     ...new Set(AllDistrict?.map((d) => d.District_Marathi)),
//   ];

//   const isAllSelected = SelectedDistrict.length === allDistricts.length;

//   const toggleDistrict = (district) => {
//     setSelectedDistrict((prev) =>
//       prev.includes(district)
//         ? prev.filter((d) => d !== district)
//         : [...prev, district],
//     );
//   };

//   const toggleAllDistricts = () => {
//     setSelectedDistrict(isAllSelected ? [] : allDistricts);
//   };
//   const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
//     const CHUNK_SIZE = 500;
//     setExportingPDF(true);
//     setloading(true);
//     await new Promise((res) => setTimeout(res, 600));
//     const originalTable = document.querySelector(`.${tableClass}`);
//     const table = document.querySelector(`.${tableClass}`);
//     if (!table) {
//       setExportingPDF(false);
//       setloading(false);
//       return;
//     }
//     try {
//       const originalRows = originalTable.querySelectorAll("tbody tr");
//       const totalRows = originalRows.length;

//       for (let start = 0; start < totalRows; start += CHUNK_SIZE) {
//         const end = Math.min(start + CHUNK_SIZE, totalRows);

//         // 🔥 Clone table
//         const table = originalTable.cloneNode(true);
//         const rows = table.querySelectorAll("tbody tr");

//         // Remove rows outside chunk
//         rows.forEach((row, index) => {
//           if (index < start || index >= end) {
//             row.remove();
//           }
//         });

//         document.body.appendChild(table);
//         const pdf = new jsPDF("p", "mm", "a4");
//         const pageWidth = pdf.internal.pageSize.getWidth();
//         const pageHeight = pdf.internal.pageSize.getHeight();

//         const topMargin = 25;
//         const sideMargin = 10;
//         const bottomMargin = 15;

//         pdf.setFontSize(16);
//         pdf.setFont("helvetica", "bold");
//         pdf.text(`${title} (${start + 1} - ${end})`, pageWidth / 2, 15, {
//           align: "center",
//         });

//         const canvas = await html2canvas(table, {
//           scale: 1,
//           useCORS: true,
//           backgroundColor: "#2C78DB",
//         });

//         const imgWidth = pageWidth - sideMargin * 2;

//         // 🔥 Correct pixel-to-mm ratio
//         const pxToMm = imgWidth / canvas.width;

//         const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
//         const usablePageHeightPx = usablePageHeightMm / pxToMm;

//         let renderedHeight = 0;
//         let pageNumber = 0;

//         while (renderedHeight < canvas.height) {
//           const sliceHeight = Math.min(
//             usablePageHeightPx,
//             canvas.height - renderedHeight,
//           );

//           const pageCanvas = document.createElement("canvas");
//           const context = pageCanvas.getContext("2d");

//           pageCanvas.width = canvas.width;
//           pageCanvas.height = sliceHeight;

//           context.drawImage(
//             canvas,
//             0,
//             renderedHeight,
//             canvas.width,
//             sliceHeight,
//             0,
//             0,
//             canvas.width,
//             sliceHeight,
//           );

//           const imgData = pageCanvas.toDataURL("image/jpeg", 0.9);

//           if (pageNumber > 0) pdf.addPage();

//           pdf.addImage(
//             imgData,
//             "JPEG",
//             sideMargin,
//             topMargin,
//             imgWidth,
//             sliceHeight * pxToMm,
//           );

//           renderedHeight += sliceHeight;
//           pageNumber++;
//         }

//         pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);

//         document.body.removeChild(table);
//         await new Promise((resolve) => setTimeout(resolve, 300));
//       }
//     } catch (error) {
//       console.error("PDF Export Error:", error);
//     } finally {
//       setExportingPDF(false);
//       setloading(false);
//     }
//   };
//   // const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
//   //   setExportingPDF(true);
//   //   await new Promise(res => setTimeout(res, 300));

//   //   const table = document.querySelector(`.${tableClass}`);
//   //   if (!table) {
//   //     setExportingPDF(false);
//   //     return;
//   //   }

//   //   const pdf = new jsPDF("p", "mm", "a4");
//   //   const pageWidth = pdf.internal.pageSize.getWidth();
//   //   const pageHeight = pdf.internal.pageSize.getHeight();

//   //   const topMargin = 25;
//   //   const sideMargin = 10;
//   //   const bottomMargin = 15;

//   //   pdf.setFontSize(16);
//   //   pdf.setFont("helvetica", "bold");
//   //   pdf.text(title, pageWidth / 2, 15, { align: "center" });

//   //   const canvas = await html2canvas(table, {
//   //     scale: 1,
//   //     useCORS: true,
//   //     backgroundColor: "#2C78DB",
//   //   });

//   //   const imgWidth = pageWidth - sideMargin * 2;

//   //   // 🔥 Correct pixel-to-mm ratio
//   //   const pxToMm = imgWidth / canvas.width;

//   //   const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
//   //   const usablePageHeightPx = usablePageHeightMm / pxToMm;

//   //   let renderedHeight = 0;
//   //   let pageNumber = 0;

//   //   while (renderedHeight < canvas.height) {
//   //     const sliceHeight = Math.min(
//   //       usablePageHeightPx,
//   //       canvas.height - renderedHeight
//   //     );

//   //     const pageCanvas = document.createElement("canvas");
//   //     const context = pageCanvas.getContext("2d");

//   //     pageCanvas.width = canvas.width;
//   //     pageCanvas.height = sliceHeight;

//   //     context.drawImage(
//   //       canvas,
//   //       0,
//   //       renderedHeight,
//   //       canvas.width,
//   //       sliceHeight,
//   //       0,
//   //       0,
//   //       canvas.width,
//   //       sliceHeight
//   //     );

//   //     const imgData = pageCanvas.toDataURL("image/jpeg", 0.9);

//   //     if (pageNumber > 0) pdf.addPage();

//   //     pdf.addImage(
//   //       imgData,
//   //       "JPEG",
//   //       sideMargin,
//   //       topMargin,
//   //       imgWidth,
//   //       sliceHeight * pxToMm
//   //     );

//   //     renderedHeight += sliceHeight;
//   //     pageNumber++;
//   //   }

//   //   pdf.save(filename);
//   //   setExportingPDF(false);
//   // };
//   return (
//     <>
//       {showmenu == 1 && (
//         <div
//           className="col-12 pb-5"
//           style={{
//             backgroundColor: "#EFF3F8",
//             height: "90vh",
//             overflowX: "hidden",
//             overflowY: "scroll",
//           }}
//         >
//           <div
//             style={{
//               filter: loading ? "blur(4px)" : "none",
//               pointerEvents: loading ? "none" : "auto",
//               transition: "0.2s ease",
//             }}
//           >
//             <div className="col-11 m-auto">
//               <div className="col-12 ">
//                 {/* <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                                     <h5 className='my-auto fw-bold'>
//                                         <img src="/Work-Order-Outwards-Blue64.png" alt="GR Outwards" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
//                                         <span className='my-auto '>{t("GR Outwards")}</span>
//                                     </h5>



//                                     <div style={{ position: "relative", width: UserRole == "State" ? "150px" : "250px", marginRight: "10px" }}>
//                                         <select
//                                             placeholder='Choose District'
//                                             value={statusofData}
//                                             onChange={(e) => setstatusofData(e.target.value)}
//                                             style={{
//                                                 width: "100%",
//                                                 padding: "8px 12px 8px 8px",
//                                                 border: "1px solid #ccc",
//                                                 borderRadius: "8px",
//                                                 backgroundColor: "#ffffffff",
//                                                 fontSize: "14px",
//                                                 color: "#333",
//                                                 boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//                                                 outline: "none"
//                                             }}>
//                                             <option value="">All</option>
//                                             <option value="false">Pending</option>
//                                             <option value="Rejected">Rejected</option>

//                                         </select>
//                                     </div>

//                                     {
//                                         UserRole == "State" && (
//                                             <div style={{ position: "relative", width: "150px", marginRight: "5px" }}>
//                                                 <select
//                                                     placeholder='Choose District'
//                                                     value={SelectedDistrict}
//                                                     onChange={(e) => setSelectedDistrict(e.target.value)}
//                                                     style={{
//                                                         width: "100%",
//                                                         padding: "8px 12px 8px 8px",
//                                                         border: "1px solid #ccc",
//                                                         borderRadius: "8px",
//                                                         backgroundColor: "#ffffffff",
//                                                         fontSize: "14px",
//                                                         color: "#333",
//                                                         boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//                                                         outline: "none"
//                                                     }}>
//                                                     <option value="" >All District</option>
//                                                     {
//                                                         AllDistrict &&
//                                                         [...new Set(AllDistrict.map(val => val.District_Marathi))].map((district, index) => {
//                                                             return (
//                                                                 <option key={index} value={district}>{district}</option>
//                                                             )
//                                                         })
//                                                     }
//                                                 </select>
//                                             </div>
//                                         )
//                                     }

//                                     {
//                                         UserRole == "State" && (
//                                             <div style={{ position: "relative", width: "150px", marginRight: "5px" }}>
//                                                 <select
//                                                     placeholder='Choose Taluka'
//                                                     value={SelectedTalukasofDistrict}
//                                                     onChange={(e) => setSelectedTalukasofDistrict(e.target.value)}
//                                                     style={{
//                                                         width: "100%",
//                                                         padding: "8px 12px 8px 8px",
//                                                         border: "1px solid #ccc",
//                                                         borderRadius: "8px",
//                                                         backgroundColor: "#ffffffff",
//                                                         fontSize: "14px",
//                                                         color: "#333",
//                                                         boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//                                                         outline: "none"
//                                                     }}>
//                                                     <option value="" disabled>Select Taluka</option>
//                                                     {
//                                                         TalukasofDistrict.length > 0 &&
//                                                         TalukasofDistrict.map((val, index) => {
//                                                             return (
//                                                                 <option key={index} value={val.ULBNameMarathi}>{val.ULBNameMarathi}</option>
//                                                             )
//                                                         })
//                                                     }
//                                                 </select>
//                                             </div>
//                                         )
//                                     }

//                                     <div style={{ position: "relative", width: UserRole == "State" ? "150px" : "250px", marginRight: "10px" }}>
//                                         <img
//                                             src="/Search32.png"
//                                             alt="Search Icon"
//                                             style={{
//                                                 position: "absolute",
//                                                 top: "50%",
//                                                 left: "10px",
//                                                 transform: "translateY(-50%)",
//                                                 width: "16px",
//                                                 height: "16px",
//                                                 opacity: 0.6
//                                             }}
//                                         />
//                                         <input
//                                             type="text"
//                                             placeholder={t("Search Here")}
//                                             onChange={(e) => setSearchTerm(e.target.value)}
//                                             value={searchTerm}
//                                             style={{
//                                                 width: "100%",
//                                                 padding: "8px 12px 8px 32px",
//                                                 border: "1px solid #ccc",
//                                                 borderRadius: "8px",
//                                                 backgroundColor: "#f1f6fc",
//                                                 fontSize: "14px",
//                                                 color: "#333",
//                                                 boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//                                                 outline: "none"
//                                             }}
//                                         />
//                                     </div>
//                                      <div className='col-4'> 

//                             <button className='btn btn-success ' onClick={() => exportTableByClassToExcel(sortedBills, "AllDistrictReleaseData.xlsx")}>{t("Download Excel")}</button>
//                                     </div>
//                                 </div> */}

//                 <div className="col-12 px-4 mb-4 mt-3">
//                   {/* ================= ROW 1 : HEADING + DOWNLOAD ================= */}
//                   <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
//                     <h5 className="fw-bold d-flex align-items-center m-0">
//                       <img
//                         src="/Work-Order-Outwards-Blue64.png"
//                         alt="GR Outwards"
//                         style={{
//                           width: "24px",
//                           height: "24px",
//                           marginRight: "6px",
//                         }}
//                       />
//                       {[24, 25, 29, 40, 41].includes(RoleID)
//                         ? t("GR Status")
//                         : t("GR Outwards")}
//                     </h5>
//                     <div className="d-flex gap-2">
//                       <button
//                         className="btn btn-success"
//                         onClick={() =>
//                           exportTableByClassToExcel(
//                             filteredBills,
//                             "AllDistrictReleaseData.xlsx",
//                           )
//                         }
//                       >
//                         {t("Download Excel")}
//                       </button>
//                       <button
//                         className="btn btn-danger"
//                         onClick={() =>
//                           downloadTableOnlyAsPDF(
//                             "GRoutwards",
//                             "GRoutwards.pdf",
//                             "GR outwards Report",
//                           )
//                         }
//                       >
//                         {t("Download PDF")}
//                       </button>
//                     </div>
//                   </div>

//                   {/* ================= ROW 2 : FILTERS + SEARCH ================= */}
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "8px",
//                       flexWrap: "nowrap",
//                     }}
//                   >
//                     {UserRole === "State" && RoleID == 29 && (
//                       <select
//                         value={typeofData}
//                         onChange={(e) => settypeofData(e.target.value)}
//                         style={{
//                           width: "150px",
//                           padding: "8px",
//                           border: "1px solid #ccc",
//                           borderRadius: "8px",
//                           fontSize: "13px",
//                           whiteSpace: "nowrap",
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                         }}
//                       >
//                         <option value="" disabled selected>
//                           Choose Data
//                         </option>
//                         <option value="District">
//                           {t(
//                             "3054-2419(Roads and bridge repair maintenance program)",
//                           )}
//                         </option>
//                         <option value="State">
//                           {t("2515-1238(MLA Representative)")}
//                         </option>
//                       </select>
//                     )}

//                     {/* Status */}
//                     <div style={{ width: "150px" }}>
//                       <select
//                         value={statusofData}
//                         onChange={(e) => setstatusofData(e.target.value)}
//                         style={{
//                           width: "100%",
//                           padding: "8px",
//                           border: "1px solid #ccc",
//                           borderRadius: "8px",
//                           backgroundColor: "#fff",
//                           fontSize: "13px",
//                           whiteSpace: "nowrap",
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                         }}
//                       >
//                         <option value="">{t("All")}</option>
//                         <option value="Approved">{t("Approved")}</option>
//                         <option value="false">{t("Pending")}</option>
//                         <option value="Rejected">{t("Rejected")}</option>
//                       </select>
//                     </div>

//                     {/* District */}
//                     {/* {UserRole === "State" && (
//       <div style={{ width: "160px" }}>
//         <select
//           value={SelectedDistrict}
//           onChange={(e) => setSelectedDistrict(e.target.value)}
//           style={{
//             width: "100%",
//             padding: "8px",
//             border: "1px solid #ccc",
//             borderRadius: "8px",
//             backgroundColor: "#fff"
//           }}
//         >
//           <option value="">{t("All District")}</option>
//           {[...new Set(AllDistrict?.map(d => d.District_Marathi))].map(
//             (district, index) => (
//               <option key={index} value={district}>
//                 {district}
//               </option>
//             )
//           )}
//         </select>
//       </div>
//     )} */}
//                     {UserRole === "State" && (
//                       <div style={{ position: "relative", width: "160px" }}>
//                         {/* Trigger */}
//                         <div
//                           onClick={() => setOpenDistrict(true)}
//                           style={{
//                             padding: "8px",
//                             border: "1px solid #ccc",
//                             borderRadius: "8px",
//                             backgroundColor: "#fff",
//                             cursor: "pointer",
//                             fontSize: "13px",
//                             whiteSpace: "nowrap",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                           }}
//                         >
//                           {SelectedDistrict.length > 0
//                             ? SelectedDistrict.join(", ")
//                             : t("Select District")}
//                         </div>

//                         {/* Dropdown */}
//                         {openDistrict && (
//                           <div
//                             style={{
//                               position: "absolute",
//                               top: "100%",
//                               left: 0,
//                               width: "100%",
//                               background: "#fff",
//                               border: "1px solid #ccc",
//                               borderRadius: "8px",
//                               boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
//                               zIndex: 10,
//                             }}
//                           >
//                             {/* All District option */}
//                             <label
//                               style={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 padding: "6px 8px",
//                                 borderBottom: "1px solid #eee",
//                                 cursor: "pointer",
//                                 fontSize: "13px",
//                                 whiteSpace: "nowrap",
//                                 overflow: "hidden",
//                                 textOverflow: "ellipsis",
//                               }}
//                             >
//                               <input
//                                 type="checkbox"
//                                 checked={isAllSelected}
//                                 onChange={toggleAllDistricts}
//                                 style={{ marginRight: "6px" }}
//                               />
//                               {t("All Districts")}
//                             </label>

//                             {/* District list */}
//                             <div
//                               style={{ maxHeight: "150px", overflowY: "auto" }}
//                             >
//                               {allDistricts.map((district, index) => (
//                                 <label
//                                   key={index}
//                                   style={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     padding: "6px 8px",
//                                     cursor: "pointer",
//                                     fontSize: "13px",
//                                     whiteSpace: "nowrap",
//                                     overflow: "hidden",
//                                     textOverflow: "ellipsis",
//                                   }}
//                                 >
//                                   <input
//                                     type="checkbox"
//                                     checked={SelectedDistrict.includes(
//                                       district,
//                                     )}
//                                     onChange={() => toggleDistrict(district)}
//                                     style={{ marginRight: "6px" }}
//                                   />
//                                   {district}
//                                 </label>
//                               ))}
//                             </div>

//                             {/* OK button */}
//                             <div
//                               style={{
//                                 borderTop: "1px solid #eee",
//                                 padding: "6px",
//                                 textAlign: "right",
//                               }}
//                             >
//                               <button
//                                 onClick={() => setOpenDistrict(false)}
//                                 style={{
//                                   padding: "4px 10px",
//                                   fontSize: "18px",
//                                   borderRadius: "6px",
//                                   border: "none",
//                                   background: "#0d6efd",
//                                   color: "#fff",
//                                   cursor: "pointer",
//                                 }}
//                               >
//                                 OK
//                               </button>
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     )}
//                     {/* Head Code Filter */}
//                       <div style={{ width: "230px" }}>
//                         <select
//                           value={SelectedHeadCode}
//                           onChange={(e) => setSelectedHeadCode(e.target.value)}
//                           style={{
//                             width: "100%",
//                             padding: "8px",
//                             border: "1px solid #ccc",
//                             borderRadius: "8px",
//                             backgroundColor: "#fff",
//                             fontSize: "13px",
//                             whiteSpace: "nowrap",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis"
//                           }}
//                         >
//                           <option value="">All Head Code</option>
 
//                           {[...new Set(
//                             technicalInwards
//                               ?.map(item => item.HeadCode)
//                               .filter(Boolean)
//                           )].map((headCode, index) => (
//                             <option key={index} value={headCode}>
//                               {headCode}
//                             </option>
//                           ))}
//                         </select>
//                       </div>
                 
//                       {/* Taluka Filter */}
//                       <div style={{ width: "160px" }}>
//                         <select
//                           value={SelectedTalukasofDistrict}
//                           onChange={(e) => setSelectedTalukasofDistrict(e.target.value)}
//                           style={{
//                             width: "100%",
//                             padding: "8px",
//                             border: "1px solid #ccc",
//                             borderRadius: "8px",
//                             backgroundColor: "#fff",
//                             fontSize: "13px",
//                             whiteSpace: "nowrap",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis"
//                           }}
//                         >
//                           <option value="">All Taluka</option>
 
//                           {[...new Set(
//                             technicalInwards
//                               ?.map(item => item.Taluka)
//                               .filter(Boolean)
//                           )].map((taluka, index) => (
//                             <option key={index} value={taluka}>
//                               {taluka}
//                             </option>
//                           ))}
//                         </select>
//                       </div>

//                     {/* Search */}
//                     <div style={{ position: "relative", width: "220px" }}>
//                       <img
//                         src="/Search32.png"
//                         alt="Search"
//                         style={{
//                           position: "absolute",
//                           top: "50%",
//                           left: "10px",
//                           transform: "translateY(-50%)",
//                           width: "16px",
//                           opacity: 0.6,
//                         }}
//                       />
//                       <input
//                         type="text"
//                         placeholder={t("Search Here")}
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         style={{
//                           width: "100%",
//                           padding: "8px 12px 8px 32px",
//                           border: "1px solid #ccc",
//                           borderRadius: "8px",
//                           backgroundColor: "#f1f6fc",
//                           fontSize: "13px",
//                           whiteSpace: "nowrap",
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                         }}
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-12 pb-5">
//                   <div
//                     className="m-auto mb-3"
//                     style={{
//                       backgroundColor: "white",
//                       padding: "40px 40px",
//                       boxShadow: "0px 0px 5px 1px #E4E8EC",
//                       borderRadius: "20px",
//                       width: "100%",
//                       maxWidth: "100%",
//                       overflowX: "hidden",
//                     }}
//                   >
//                     <div
//                       className="col-12 tableDesign"
//                       style={{ background: "#2C78DB", overflowX: "scroll" }}
//                     >
//                       <table
//                         className="m-0 p-0 GRoutwards"
//                         style={{ width: "100%", borderCollapse: "collapse" }}
//                       >
//                         <thead>
//                           <tr
//                             style={{
//                               color: "white",
//                               border: "none",
//                               height: "3rem",
//                               fontSize: "18px",
//                               fontWeight: "400",
//                             }}
//                           >
//                             <th
//                               style={{ minWidth: "70px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Sr.No.")}
//                             </th>
//                             <th
//                               style={{ minWidth: "100px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("GR UID")}
//                             </th>
//                             <th
//                               style={{ minWidth: "100px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("GR Number")}
//                             </th>
//                             {UserRole === "State" && RoleID != 29 ? (
//                               ""
//                             ) : (
//                               <th
//                                 style={{ minWidth: "180px", padding: "8px" }}
//                                 rowSpan={2}
//                                 colSpan={1}
//                               >
//                                 {t("Head Code")}
//                               </th>
//                             )}
//                             <th
//                               style={{ minWidth: "180px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Total Works Created")}
//                             </th>
//                             <th
//                               style={{ minWidth: "100px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Approved Year")}
//                             </th>
//                             <th
//                               style={{ minWidth: "80px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("District")}
//                             </th>
//                             <th
//                               style={{ minWidth: "70px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Taluka")}
//                             </th>
//                             <th
//                               style={{ minWidth: "100px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Work Amount")}
//                             </th>
//                             <th
//                               style={{ minWidth: "200px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("GR Copy")}
//                             </th>
//                             <th
//                               style={{ minWidth: "180px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("GR Approval Copy")}
//                             </th>
//                             <th
//                               style={{ minWidth: "150px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Creation Date")}
//                             </th>
//                             <th
//                               style={{ minWidth: "150px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Uploaded By")}
//                             </th>
//                             <th
//                               style={{ minWidth: "150px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Edited By")}
//                             </th>
//                             <th
//                               style={{ padding: "7px 10px", minWidth: "160px" }}
//                               rowSpan={2}
//                             >
//                               {t("Rejected/Send Back")}
//                             </th>
//                             <th
//                               style={{ padding: "7px 10px", minWidth: "160px" }}
//                               rowSpan={2}
//                             >
//                               {t("Remark")}
//                             </th>
//                             <th style={headerStyle} colSpan={2}>
//                               {t("Approved by")}
//                             </th>
//                             {UserRole === "State" && (
//                               <th
//                                 style={{ minWidth: "150px", padding: "8px" }}
//                                 rowSpan={2}
//                                 colSpan={1}
//                               >
//                                 {t("View Edit log")}
//                               </th>
//                             )}
//                             {/* <th style={{ width: "12%", textAlign: "center", border: "1px solid white" }} colSpan={1} rowSpan={2}>Details</th> */}
//                           </tr>
//                           <tr
//                             style={{
//                               color: "white",
//                               border: "none",
//                               height: "3rem",
//                               fontSize: "18px",
//                               fontWeight: "400",
//                             }}
//                           >
//                             <th style={headerStyle}>
//                               {t("RDD Section Officer")}
//                             </th>
//                             <th style={headerStyle}>
//                               {t("Deputy / Joint Secretary")}
//                             </th>
//                           </tr>
//                         </thead>

//                         <tbody>
//                           <>
//                             {displayedGRS?.length === 0 ? (
//                               <tr>
//                                 <td
//                                   colSpan="30"
//                                   style={{
//                                     textAlign: "center",
//                                     padding: "20px",
//                                     backgroundColor: "#f9f9f9",
//                                   }}
//                                 >
//                                   {t("No data available")}
//                                 </td>
//                               </tr>
//                             ) : (
//                               displayedGRS?.map((proposal, index) => {
//                                 const bgColor =
//                                   index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                 return (
//                                   <tr
//                                     style={{
//                                       backgroundColor: bgColor,
//                                       fontSize: "18px",
//                                       fontWeight: "400",
//                                     }}
//                                     key={proposal.DemandGenerationID || index}
//                                   >
//                                     <td
//                                       style={{
//                                         fontSize: "18px",
//                                         padding: "5px",
//                                       }}
//                                     >
//                                       {indexOfFirstBill + index + 1}
//                                     </td>
//                                     <td
//                                       style={{
//                                         fontSize: "18px",
//                                         padding: "5px",
//                                       }}
//                                     >
//                                       {proposal.GRID}
//                                     </td>
//                                     <td
//                                       style={{
//                                         fontSize: "18px",
//                                         padding: "5px",
//                                       }}
//                                     >
//                                       {proposal.GRNumber}
//                                     </td>
//                                     {UserRole === "State" && RoleID != 29 ? (
//                                       ""
//                                     ) : (
//                                       <td
//                                         style={{
//                                           fontSize: "18px",
//                                           padding: "5px",
//                                         }}
//                                       >
//                                         {proposal.HeadCode}
//                                       </td>
//                                     )}
//                                     <td
//                                       style={{
//                                         fontSize: "18px",
//                                         padding: "5px",
//                                         textAlign: "center",
//                                       }}
//                                     >
//                                       <button
//                                         className="m-auto text-center"
//                                         style={{
//                                           width: "6rem",
//                                           fontWeight: "650",
//                                           padding: "6px 1px",
//                                           display: "flex",
//                                           justifyContent: "center",
//                                           alignItems: "center",
//                                           gap: "0.1rem",
//                                           background:
//                                             "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
//                                           color: "white",
//                                           borderRadius: "8px",
//                                           margin: "2px",
//                                         }}
//                                         onClick={() => {
//                                           setgrID(proposal.GRID);
//                                           setgrNumber(proposal.GRNumber); // Assuming you have this state
//                                           setShowmenu(3); // Using 3 for "Works View" to avoid conflict with logs (2)
//                                           fetchWorksByGR(proposal.GRID);
//                                         }}
//                                       >
//                                         <img
//                                           src="/view32.png"
//                                           alt="view"
//                                           className="me-1"
//                                           style={{
//                                             width: "12px",
//                                             height: "12px",
//                                           }}
//                                         />
//                                         {t("View Works")}
//                                       </button>
//                                     </td>
//                                     <td
//                                       style={{
//                                         fontSize: "18px",
//                                         padding: "5px",
//                                       }}
//                                     >
//                                       {proposal.ProposalYear}
//                                     </td>
//                                     <td
//                                       style={{
//                                         fontSize: "18px",
//                                         padding: "5px",
//                                       }}
//                                     >
//                                       {proposal.ZillaParishad}
//                                     </td>
//                                     <td
//                                       style={{
//                                         fontSize: "18px",
//                                         padding: "5px",
//                                       }}
//                                     >
//                                       {proposal.Taluka}
//                                     </td>
//                                     <td
//                                       style={{
//                                         fontSize: "18px",
//                                         padding: "5px",
//                                       }}
//                                     >
//                                       {proposal.GRAmount}
//                                     </td>
//                                     {/* <td  style={{ fontSize: "12px", padding: "5px" }}>{proposal.GRCopy}</td>
//                                                     <td  style={{ fontSize: "12px", padding: "5px" }}>{proposal.GRDraftCopy}</td> */}
//                                     <td style={{ padding: "8px" }}>
//                                       {proposal.GRCopy ? (
//                                         <a
//                                           href={`${apiurl}/ProjectDocsImages/${proposal.GRCopy}`}
//                                           target="_blank"
//                                           rel="noreferrer"
//                                         >
//                                           {proposal.GRCopy}
//                                         </a>
//                                       ) : (
//                                         <p className="text-danger my-auto fw-bold">
//                                           {t("No File")}
//                                         </p>
//                                       )}
//                                     </td>
//                                     <td style={{ padding: "8px" }}>
//                                       {proposal.GRDraftCopy ? (
//                                         <a
//                                           href={`${apiurl}/GRDraftCopy/${proposal.GRDraftCopy}`}
//                                           target="_blank"
//                                           rel="noreferrer"
//                                         >
//                                           {proposal.GRDraftCopy}
//                                         </a>
//                                       ) : (
//                                         <p className="text-danger my-auto fw-bold">
//                                           {t("No File")}
//                                         </p>
//                                       )}
//                                     </td>
//                                     <td
//                                       style={{
//                                         fontSize: "18px",
//                                         padding: "5px",
//                                       }}
//                                     >
//                                       {formatDateTime(proposal.Date)}
//                                     </td>
//                                     <td
//                                       style={{
//                                         fontSize: "18px",
//                                         padding: "5px",
//                                       }}
//                                     >
//                                       {proposal.Uploadedby == null
//                                         ? "--"
//                                         : proposal.Uploadedby}
//                                     </td>
//                                     <td
//                                       style={{
//                                         fontSize: "18px",
//                                         padding: "5px",
//                                       }}
//                                     >
//                                       {proposal.EditedBy ? (
//                                         <p className="text-black my-auto fw-bold">
//                                           {proposal.EditedBy}
//                                         </p>
//                                       ) : (
//                                         <p className="text-danger my-auto fw-bold">
//                                           {t("No One")}
//                                         </p>
//                                       )}
//                                     </td>
//                                     <td style={{ padding: "8px 8px" }}>
//                                       {proposal.GRStatus === "Pending"
//                                         ? "No"
//                                         : proposal.GRStatus}
//                                     </td>
//                                     <td style={{ padding: "8px 8px" }}>
//                                       {proposal.Remark || "--"}
//                                     </td>
//                                     <td
//                                       style={{
//                                         padding: "8px",
//                                         textAlign: "center",
//                                       }}
//                                     >
//                                       {proposal.Approve2 === "true" ? (
//                                         <div
//                                           className="m-auto"
//                                           style={{
//                                             width: "20px",
//                                             height: "20px",
//                                             borderRadius: "6px",
//                                             backgroundColor: "#16C60C",
//                                             border: "none",
//                                             display: "flex",
//                                             justifyContent: "center",
//                                             alignItems: "center",
//                                             fontSize: "13px",
//                                             color: "white",
//                                             boxShadow:
//                                               "0 2px 4px rgba(0,0,0,0.1)",
//                                           }}
//                                         >
//                                           ✓
//                                         </div>
//                                       ) : proposal.Approve2 === "false" ? (
//                                         <div
//                                           className="m-auto"
//                                           style={{
//                                             width: "20px",
//                                             height: "20px",
//                                             borderRadius: "6px",
//                                             backgroundColor: "#dc2626",
//                                             border: "none",
//                                             display: "flex",
//                                             justifyContent: "center",
//                                             alignItems: "center",
//                                             fontSize: "13px",
//                                             color: "white",
//                                             boxShadow:
//                                               "0 2px 4px rgba(0,0,0,0.1)",
//                                           }}
//                                         >
//                                           ✕
//                                         </div>
//                                       ) : (
//                                         "-"
//                                       )}
//                                     </td>
//                                     <td
//                                       style={{
//                                         padding: "8px",
//                                         textAlign: "center",
//                                       }}
//                                     >
//                                       {proposal.Approve3 === "true" ? (
//                                         <div
//                                           className="m-auto"
//                                           style={{
//                                             width: "20px",
//                                             height: "20px",
//                                             borderRadius: "6px",
//                                             backgroundColor: "#16C60C",
//                                             border: "none",
//                                             display: "flex",
//                                             justifyContent: "center",
//                                             alignItems: "center",
//                                             fontSize: "13px",
//                                             color: "white",
//                                             boxShadow:
//                                               "0 2px 4px rgba(0,0,0,0.1)",
//                                           }}
//                                         >
//                                           ✓
//                                         </div>
//                                       ) : proposal.Approve3 === "false" ? (
//                                         <div
//                                           className="m-auto"
//                                           style={{
//                                             width: "20px",
//                                             height: "20px",
//                                             borderRadius: "6px",
//                                             backgroundColor: "#dc2626",
//                                             border: "none",
//                                             display: "flex",
//                                             justifyContent: "center",
//                                             alignItems: "center",
//                                             fontSize: "13px",
//                                             color: "white",
//                                             boxShadow:
//                                               "0 2px 4px rgba(0,0,0,0.1)",
//                                           }}
//                                         >
//                                           ✕
//                                         </div>
//                                       ) : (
//                                         "-"
//                                       )}
//                                     </td>

//                                     {UserRole === "State" && (
//                                       <td
//                                         style={{
//                                           fontSize: "18px",
//                                           padding: "5px",
//                                         }}
//                                       >
//                                         <button
//                                           className="btn btn-success btn-sm"
//                                           onClick={() => {
//                                             setShowmenu(2);
//                                             logofgridfetchfunction(
//                                               proposal.GRID,
//                                               proposal.GRNumber,
//                                             );
//                                           }}
//                                         >
//                                           {t("View")}
//                                         </button>
//                                       </td>
//                                     )}

//                                     {/* <td style={{ padding: '8px' }}>{proposal.Proposal_copy}</td> */}
//                                     {/* <td>
//                                                                 <button
//                                                                     className='m-auto'
//                                                                     onClick={() => selectedBillDetails(proposal.GRID)}
//                                                                     style={{
//                                                                         cursor: 'pointer',
//                                                                         background: "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
//                                                                         color: 'white',
//                                                                         border: 'none',
//                                                                         padding: '8px 20px',
//                                                                         borderRadius: '4px',
//                                                                         fontSize: "12px",
//                                                                         display: "flex",
//                                                                         justifyContent: "center",
//                                                                         alignItems: 'center'
//                                                                     }}
//                                                                 >
//                                                                     <img src="/view32.png" alt="view" className='me-1' style={{ width: "12px", height: "12px" }} />
//                                                                     View
//                                                                 </button>
//                                                             </td> */}
//                                   </tr>
//                                 );
//                               })
//                             )}
//                                 <tr
//                                 style={{
//                                   fontWeight: "600",
//                                   backgroundColor: "#f0f0f0",
//                                   fontSize: "18px",
//                                   textAlign:"right"
//                                 }}
//                               >
//                                 <td colSpan={UserRole === "State" && RoleID != 29 ? 7 : 8} style={{ textAlign: "right", padding: "8px" }}>
//                                   {t("Page Total")}
//                                 </td>

//                                 <td style={{ padding: "8px" }}  >
//                                   ₹ {pagetotalProposalAmount.toLocaleString("en-IN")}
//                                 </td>

//                                 {/* remaining columns */}
//                                 <td colSpan={UserRole === "State" ? 19 : 20}></td>
//                               </tr>
//                             <tr
//                               style={{
//                                 fontWeight: "600",
//                                 backgroundColor: "#f0f0f0",
//                                 fontSize: "18px",
//                               }}
//                             >
//                               <td
//                                 colSpan={
//                                   UserRole === "State" && RoleID != 29 ? 7 : 8
//                                 }
//                                 style={{ textAlign: "right", padding: "8px" }}
//                               >
//                                 {t("Gross Amount")}
//                               </td>

//                               <td style={{ padding: "8px" }}>
//                                 ₹ {totalProposalAmount.toLocaleString("en-IN")}
//                               </td>

//                               {/* remaining columns */}
//                               <td colSpan={UserRole === "State" ? 19 : 20}></td>
//                             </tr>
//                           </>
//                         </tbody>
//                       </table>
//                     </div>
//                     <div className="col-12 mt-4">
//                       <div className="row">
//                         <div className="col-6">
//                           <p
//                             className="text-gray-600"
//                             style={{ fontSize: "18px", margin: 0 }}
//                           >
//                             {t("Showing")} {indexOfFirstBill + 1} {t("to")}{" "}
//                             {Math.min(indexOfLastBill, filteredBills?.length)}{" "}
//                             {t("of")} {filteredBills?.length} {t("entries")}
//                           </p>
//                         </div>
//                         <div
//                           className="col-6 text-end"
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "end",
//                           }}
//                         >
//                           <GooglePagination
//                             currentPage={currentPage}
//                             totalPages={totalPages}
//                             onPageChange={setCurrentPage}
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {selectedProposal && (
//                 <div
//                   onClick={() => setSelectedProposal(null)}
//                   style={{
//                     position: "fixed",
//                     top: 0,
//                     left: 0,
//                     width: "100vw",
//                     height: "100vh",
//                     backgroundColor: "rgba(0, 0, 0, 0.84)",
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     zIndex: 9999,
//                   }}
//                 >
//                   <div
//                     onClick={(e) => e.stopPropagation()}
//                     style={{
//                       backgroundColor: "white",
//                       padding: "40px 40px",
//                       borderRadius: "20px",
//                       width: "50%",
//                       maxHeight: "90vh",
//                       overflow: "hidden",
//                       boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
//                       position: "relative",
//                     }}
//                   >
//                     <div className="col-12">
//                       <div className="col-12  mb-3">
//                         <div className="row">
//                           <div className="col-6">
//                             <h5>GR Details</h5>
//                           </div>

//                           <div
//                             className="col-6"
//                             style={{
//                               display: "flex",
//                               justifyContent: "flex-end",
//                             }}
//                           >
//                             <button
//                               onClick={() => setSelectedProposal(null)}
//                               style={{
//                                 width: "32px",
//                                 height: "32px",
//                                 borderRadius: "50%",
//                                 backgroundColor: "red",
//                                 border: "none",
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center",
//                                 cursor: "pointer",
//                                 fontSize: "24px",
//                                 fontWeight: "bold",
//                                 color: "white",
//                                 lineHeight: 1,
//                               }}
//                             >
//                               ×
//                             </button>
//                           </div>
//                         </div>
//                       </div>

//                       <div
//                         className="col-12"
//                         style={{
//                           height: "59vh",
//                           overflowX: "hidden",
//                           overflowY: "scroll",
//                           scrollBehavior: "smooth",
//                         }}
//                       >
//                         <table
//                           style={{
//                             width: "100%",
//                             height: "100%",
//                             borderCollapse: "collapse",
//                           }}
//                         >
//                           <tbody>
//                             {Object.entries(selectedProposal).map(
//                               ([key, value], index) => (
//                                 <>
//                                   <tr
//                                     key={key}
//                                     style={{
//                                       backgroundColor:
//                                         index % 2 === 0 ? "#2B75D5" : "#cce0f9",
//                                       border: "1px solid #cce0f9",
//                                     }}
//                                   >
//                                     <td
//                                       style={{
//                                         fontWeight: "bold",
//                                         padding: "8px",
//                                         width: "40%",
//                                         backgroundColor: "#2B75D5",
//                                         color: "white",
//                                         border: "1px solid #cce0f9",
//                                       }}
//                                     >
//                                       {key}
//                                     </td>
//                                     <td
//                                       style={{
//                                         padding: "8px",
//                                         color: "black",
//                                         backgroundColor:
//                                           index % 2 === 0
//                                             ? "#E3EBF5"
//                                             : "#D0DEF1",
//                                         whiteSpace: "nowrap",
//                                         textOverflow: "ellipsis",
//                                         overflow: "hidden",
//                                         maxWidth: "160px",
//                                       }}
//                                     >
//                                       {/* Handle Upload Bill Copy link */}
//                                       {key === "GR Copy" && value ? (
//                                         <a
//                                           href={`${apiurl}/ProjectDocsImages/${value}`}
//                                           target="_blank"
//                                           rel="noreferrer"
//                                         >
//                                           {value}
//                                         </a>
//                                       ) : key === "GR Approval Copy" &&
//                                         value ? (
//                                         <a
//                                           href={`${apiurl}/GRDraftCopy/${value}`}
//                                           target="_blank"
//                                           rel="noreferrer"
//                                         >
//                                           {value}
//                                         </a>
//                                       ) : value === null || value === "" ? (
//                                         "-"
//                                       ) : (
//                                         value.toString()
//                                       )}
//                                     </td>
//                                   </tr>
//                                 </>
//                               ),
//                             )}
//                           </tbody>
//                         </table>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//           {loading && (
//             <div
//               style={{
//                 position: "fixed",
//                 top: 0,
//                 left: 0,
//                 width: "100%",
//                 height: "100%",
//                 background: "rgba(255,255,255,0.4)",
//                 backdropFilter: "blur(2px)",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 zIndex: 9999,
//               }}
//             >
//               <div className="Adminloader"></div>
//             </div>
//           )}
//         </div>
//       )}

//       {showmenu == 2 && (
//         <div
//           className="col-12 pb-5"
//           style={{
//             backgroundColor: "#EFF3F8",
//             height: "90vh",
//             overflowX: "hidden",
//             overflowY: "scroll",
//             position: "relative",
//           }}
//         >
//           <div
//             style={{
//               filter: loading ? "blur(4px)" : "none",
//               pointerEvents: loading ? "none" : "auto",
//               transition: "0.2s ease",
//             }}
//           >
//             <div className="col-11 m-auto">
//               <div className="col-12 ">
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "15px",
//                     padding: "10px 4rem",
//                   }}
//                 >
//                   <button
//                     className="btn btn-danger px-3 py-1"
//                     onClick={() => {
//                       setgrID();
//                       setShowmenu(1);
//                       setgrlogData([]);
//                     }}
//                   >
//                     {t("Back")}
//                   </button>

//                   <h5 className="my-auto fw-bold">
//                     <img
//                       src="/Work-Order-Outwards-Blue64.png"
//                       alt="GR Outwards"
//                       style={{ width: "24px", height: "24px" }}
//                       className="my-auto me-1"
//                     />
//                     <span className="my-auto ">
//                       GR- {grId} {t("Logs")}
//                     </span>
//                   </h5>
//                 </div>

//                 <div className="col-12 pb-5">
//                   <div
//                     className="m-auto mb-3"
//                     style={{
//                       backgroundColor: "white",
//                       padding: "40px 40px",
//                       boxShadow: "0px 0px 5px 1px #E4E8EC",
//                       borderRadius: "20px",
//                       width: "100%",
//                       maxWidth: "100%",
//                       overflowX: "hidden",
//                     }}
//                   >
//                     <div
//                       className="col-12 tableDesign"
//                       style={{ background: "#2C78DB", overflowX: "scroll" }}
//                     >
//                       <table
//                         className="m-0 p-0"
//                         style={{ width: "100%", borderCollapse: "collapse" }}
//                       >
//                         <thead>
//                           <tr
//                             style={{
//                               color: "white",
//                               border: "none",
//                               height: "3rem",
//                               fontSize: "18px",
//                               fontWeight: "400",
//                             }}
//                           >
//                             <th style={{ minWidth: "70px", padding: "8px" }}>
//                               Sr.No.
//                             </th>
//                             <th style={{ minWidth: "100px", padding: "8px" }}>
//                               Action
//                             </th>
//                             <th style={{ minWidth: "100px", padding: "8px" }}>
//                               Entity ID
//                             </th>
//                             <th style={{ minWidth: "100px", padding: "8px" }}>
//                               Entity Type
//                             </th>
//                             <th style={{ minWidth: "100px", padding: "8px" }}>
//                               Performed By
//                             </th>
//                             <th style={{ minWidth: "100px", padding: "8px" }}>
//                               Role
//                             </th>
//                             <th style={{ minWidth: "100px", padding: "8px" }}>
//                               Date
//                             </th>
//                           </tr>
//                         </thead>

//                         <tbody>
//                           {currentlogBills?.length === 0 ? (
//                             <tr>
//                               <td
//                                 colSpan="30"
//                                 style={{
//                                   textAlign: "center",
//                                   padding: "20px",
//                                   backgroundColor: "#f9f9f9",
//                                 }}
//                               >
//                                 No data available
//                               </td>
//                             </tr>
//                           ) : (
//                             currentlogBills.map((proposal, index) => {
//                               const bgColor =
//                                 index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";

//                               return (
//                                 <tr
//                                   style={{
//                                     backgroundColor: bgColor,
//                                     fontSize: "18px",
//                                     fontWeight: "400",
//                                   }}
//                                   key={index}
//                                 >
//                                   <td
//                                     style={{ fontSize: "18px", padding: "5px" }}
//                                   >
//                                     {indexOfFirstlogBill + index + 1}
//                                   </td>
//                                   <td
//                                     style={{ fontSize: "18px", padding: "5px" }}
//                                   >
//                                     {proposal.ActionType}
//                                   </td>
//                                   <td
//                                     style={{ fontSize: "18px", padding: "5px" }}
//                                   >
//                                     {proposal.EntityID}
//                                   </td>
//                                   <td
//                                     style={{ fontSize: "18px", padding: "5px" }}
//                                   >
//                                     {proposal.EntityType}
//                                   </td>
//                                   <td
//                                     style={{ fontSize: "18px", padding: "5px" }}
//                                   >
//                                     {proposal.PerformedBy}
//                                   </td>
//                                   <td
//                                     style={{ fontSize: "18px", padding: "5px" }}
//                                   >
//                                     {proposal.Role}
//                                   </td>
//                                   <td
//                                     style={{ fontSize: "18px", padding: "5px" }}
//                                   >
//                                     {new Date(
//                                       proposal.ActionTimestamp,
//                                     ).toLocaleString("en-IN")}
//                                   </td>
//                                 </tr>
//                               );
//                             })
//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                     <div className="col-12 mt-4">
//                       <div className="row">
//                         <div className="col-6">
//                           <p
//                             className="text-gray-600"
//                             style={{ fontSize: "18px", margin: 0 }}
//                           >
//                             Showing {indexOfFirstlogBill + 1} to{" "}
//                             {Math.min(
//                               indexOfFirstlogBill + 1,
//                               grlogData?.length,
//                             )}{" "}
//                             of {grlogData?.length} entries
//                           </p>
//                         </div>
//                         <div
//                           className="col-6 text-end"
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "end",
//                           }}
//                         >
//                           <button
//                             onClick={() => setcurrentlogpage(1)}
//                             disabled={currentlogPage === 1}
//                             style={{
//                               backgroundColor: "white",
//                               color: "black",
//                               border: "1px solid lightgrey",
//                               cursor: "pointer",
//                               fontSize: "24px",
//                             }}
//                           >
//                             &laquo;
//                           </button>
//                           <button
//                             onClick={() =>
//                               setcurrentlogpage(currentlogPage - 1)
//                             }
//                             disabled={currentlogPage === 1}
//                             style={{
//                               backgroundColor: "white",
//                               color: "black",
//                               border: "1px solid lightgrey",
//                               cursor: "pointer",
//                               fontSize: "24px",
//                               borderLeft: "none",
//                             }}
//                           >
//                             &lt;
//                           </button>
//                           <button
//                             style={{
//                               background:
//                                 "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
//                               color: "white",
//                               cursor: "pointer",
//                               fontSize: "24px",
//                               width: "3rem",
//                               border: "1px solid lightgrey",
//                               borderLeft: "none",
//                             }}
//                           >
//                             {currentlogPage}
//                           </button>
//                           <button
//                             onClick={() =>
//                               setcurrentlogpage(currentlogPage + 1)
//                             }
//                             disabled={currentlogPage === totallogPages}
//                             style={{
//                               backgroundColor: "white",
//                               color: "black",
//                               border: "1px solid lightgrey",
//                               cursor: "pointer",
//                               fontSize: "24px",
//                               borderLeft: "none",
//                             }}
//                           >
//                             &gt;
//                           </button>
//                           <button
//                             onClick={() => setcurrentlogpage(totallogPages)}
//                             disabled={currentlogPage === totallogPages}
//                             style={{
//                               backgroundColor: "white",
//                               color: "black",
//                               border: "1px solid lightgrey",
//                               cursor: "pointer",
//                               fontSize: "24px",
//                               borderLeft: "none",
//                             }}
//                           >
//                             &raquo;
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           {loading && (
//             <div
//               style={{
//                 position: "fixed",
//                 top: 0,
//                 left: 0,
//                 width: "100%",
//                 height: "100%",
//                 background: "rgba(255,255,255,0.4)",
//                 backdropFilter: "blur(2px)",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 zIndex: 9999,
//               }}
//             >
//               <div className="Adminloader"></div>
//             </div>
//           )}
//         </div>
//       )}

//       {showmenu == 3 && (
//         <div
//           className="col-12 pb-5"
//           style={{
//             backgroundColor: "#EFF3F8",
//             height: "90vh",
//             overflowX: "hidden",
//             overflowY: "scroll",
//             position: "relative",
//           }}
//         >
//           <div
//             style={{
//               filter: loading ? "blur(4px)" : "none",
//               pointerEvents: loading ? "none" : "auto",
//               transition: "0.2s ease",
//             }}
//           >
//             <div className="col-11 m-auto">
//               <div className="col-12 ">
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "15px",
//                     padding: "10px 4rem",
//                   }}
//                 >
//                   <button
//                     className="btn btn-danger px-3 py-1"
//                     onClick={() => {
//                       setShowmenu(1);
//                       setWorksData([]);
//                     }}
//                   >
//                     {t("Back")}
//                   </button>
//                   <h5 className="my-auto fw-bold">
//                     <img
//                       src="/Work-Order-Outwards-Blue64.png"
//                       alt="Works"
//                       style={{ width: "24px", height: "24px" }}
//                       className="my-auto me-1"
//                     />
//                     <span className="my-auto ">
//                       {t("Works under GR")} {grId}
//                     </span>
//                   </h5>
//                 </div>

//                 <div className="col-12 pb-5">
//                   <div
//                     className="m-auto mb-3"
//                     style={{
//                       backgroundColor: "white",
//                       padding: "30px",
//                       boxShadow: "0px 0px 5px 1px #E4E8EC",
//                       borderRadius: "20px",
//                       width: "100%",
//                     }}
//                   >
//                     <div
//                       className="col-12 tableDesign"
//                       style={{ background: "#2C78DB", overflowX: "auto" }}
//                     >
//                       <table
//                         className="m-0 p-0"
//                         style={{ width: "100%", borderCollapse: "collapse" }}
//                       >
//                         <thead>
//                           <tr
//                             style={{
//                               color: "white",
//                               border: "none",
//                               height: "3rem",
//                               fontSize: "18px",
//                             }}
//                           >
//                             <th style={{ padding: "8px" }}>{t("Sr.No.")}</th>
//                             <th style={{ minWidth: "150px", padding: "8px" }}>
//                               {t("Work Name")}
//                             </th>
//                             <th style={{ minWidth: "100px", padding: "8px" }}>
//                               {t("Job ID")}
//                             </th>
//                             <th style={{ minWidth: "120px", padding: "8px" }}>
//                               {t("Gram Panchayat")}
//                             </th>
//                             <th style={{ minWidth: "100px", padding: "8px" }}>
//                               {t("Type of Work")}
//                             </th>
//                             <th style={{ minWidth: "100px", padding: "8px" }}>
//                               {t("Work Date")}
//                             </th>
//                             <th style={{ minWidth: "100px", padding: "8px" }}>
//                               {t("Work Unique ID")}
//                             </th>
//                             <th style={{ minWidth: "100px", padding: "8px" }}>
//                               {t("Remark")}
//                             </th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {worksData?.length === 0 ? (
//                             <tr>
//                               <td
//                                 colSpan="8"
//                                 style={{
//                                   textAlign: "center",
//                                   padding: "20px",
//                                   backgroundColor: "#f9f9f9",
//                                 }}
//                               >
//                                 {t("No works found for this GR")}
//                               </td>
//                             </tr>
//                           ) : (
//                             worksData.map((work, index) => (
//                               <tr
//                                 key={index}
//                                 style={{
//                                   backgroundColor:
//                                     index % 2 === 0 ? "#E5F4FB" : "#CFE4F1",
//                                   fontSize: "18px",
//                                 }}
//                               >
//                                 <td style={{ padding: "8px" }}>{index + 1}</td>
//                                 <td style={{ padding: "8px" }}>
//                                   {work.Work_name}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {work.JOB_ID}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {work.Gram_panchayat}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {work.typeOfWork}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {new Date(
//                                     work.created_at,
//                                   ).toLocaleDateString("en-IN")}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {work.workuniqueid}
//                                 </td>
//                                 <td style={{ padding: "8px" }}>
//                                   {work.workRemark}
//                                 </td>
//                               </tr>
//                             ))
//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default GrOutwards;
